(() => {
//working bundle - With CDN Links.
//import kendo from '@progress/kendo-ui';
//import { isDate } from 'util';
let $254a84bc556d8bd3$export$8e0397c03d8b0af5 = new WeakMap();
class $254a84bc556d8bd3$var$Utilities {
    constructor(){
        $(document).on('change', 'input', function(e) {
            var currentInput = $(e.target);
            var errorSign = currentInput.closest('div').find('.fa-exclamation-circle.text-danger');
            if (errorSign !== undefined && errorSign.length > 0) errorSign.remove();
        });
        $(document).on('focus', 'textarea', function(e) {
            var currentInput = $(e.target);
            var errorSign = currentInput.closest('.row').find('label .fa-exclamation-circle.text-danger');
            if (errorSign !== undefined && errorSign.length > 0) errorSign.remove();
        });
    }
    IsInternetExplorer() {
        let ua = window.navigator.userAgent;
        let oldIE = ua.indexOf('MSIE ');
        let newIE = ua.indexOf('Trident/');
        return oldIE > -1 || newIE > -1;
    }
    IsEdgeBrowser() {
        return /Edge\/\d./i.test(navigator.userAgent);
    }
    LoadHtmlTemplate(path, options, callback) {
        $.get(path, {
            'partialViewPath': options.viewName,
            'tyrePosition': options.positionLabel
        }).done(function(template) {
            var $template = $(template);
            callback($template);
        });
    }
    isDate(date) {
        return date instanceof Date && !isNaN(date.valueOf());
    }
    IsInArray(date, dates) {
        for(let idx = 0, length = dates.length; idx < length; idx++){
            let d = dates[idx];
            if (this.isDate(d)) {
                if (date.getFullYear() === d.getFullYear() && date.getMonth() === d.getMonth() && date.getDate() === d.getDate()) return true;
            }
        }
        return false;
    }
    IsEven(n) {
        return n % 2 === 0;
    }
    GetMonthNames() {
        return [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ];
    }
    ShowNextRow(currentDomElement, nextXrows, targetClass) {
        $(currentDomElement).parents('.' + targetClass).nextAll(':lt(' + nextXrows + ')').show();
    }
    CheckIfMobilePhoneProvided(inputList) {
        var regex = /^(\+44\s?7\d{3}|\(?07\d{3}\)?)\s?\d{3}\s?\d{3}$/;
        if (inputList !== undefined && inputList.length > 0) for(var index = 0; index < inputList.length; index++){
            var currentInput = inputList[index];
            var phoneNumber = $(currentInput).val();
            if (regex.test(phoneNumber) === true) return true;
        }
        return false;
    }
    GetVisibleCount() {
        // Left-align the breadcrumbs to simplify the calculation
        var offsetWidth = $('.mobile-breadcrumb-nav')[0].offsetWidth;
        var justifyContent = $('.mobile-breadcrumb-nav').css('justify-content');
        var visibleItemCount = 0;
        $('.mobile-breadcrumb-nav').css('justify-content', 'left');
        $('.mobile-breadcrumb-nav li').each(function(index) {
            var right = $(this).position().left + $(this).outerWidth();
            if (right > offsetWidth) {
                // Exit, because our breadcrumb is not completely visible
                visibleItemCount = index;
                return false;
            }
        });
        // Restore alignment, as soon as we know how many breadcrumbs are visible
        $('.mobile-breadcrumb-nav').css('justify-content', justifyContent);
        return visibleItemCount;
    }
    FormatMobileBreadcrumbNav() {
        var serviceBreadcrumbs = $('.mobile-breadcrumb-nav li');
        serviceBreadcrumbs.show();
        var scrollWidth = $('.mobile-breadcrumb-nav')[0].scrollWidth;
        var offsetWidth = $('.mobile-breadcrumb-nav')[0].offsetWidth;
        var contentFits = scrollWidth <= offsetWidth;
        // Work out how many breadcrumbs will fit in space
        var itemCount = serviceBreadcrumbs.length;
        var visibleItemCount = 0;
        if (!contentFits) {
            // Show overflow buttons, which will reduce the size of our container, so
            // calculate visible breadcrumbs afterwards
            $('.mobile-breadcrumb-overflow').parent().show();
            visibleItemCount = this.GetVisibleCount();
        } else {
            $('.mobile-breadcrumb-nav').css('justify-content', 'center');
            $('.mobile-breadcrumb-overflow').parent().hide();
            return;
        }
        // Works out a range that positions the active breadcrumb two positions from the end
        // using a 1-based active index
        var activeIndex = serviceBreadcrumbs.index($('.mobile-breadcrumb-nav li.active')) + 1;
        var end = activeIndex + 2;
        if (end > itemCount) end = itemCount;
        var start;
        if (end < visibleItemCount) {
            start = 1;
            end = visibleItemCount;
        } else start = end - visibleItemCount + 1;
        var range = {
            active: activeIndex,
            start: start,
            end: end,
            left: start - 1,
            right: itemCount - end
        };
        // Show buttons that fall within our visible range and hide the rest
        $('.mobile-breadcrumb-nav').css('justify-content', 'space-between');
        $('#leftOverflow').text('-' + (range.left > 0 ? range.left : ''));
        $('#rightOverflow').text('+' + (range.right > 0 ? range.right : ''));
        $('.mobile-breadcrumb-nav li').each(function(index) {
            if (index + 1 < range.start || index + 1 > range.end) $(this).hide();
            else $(this).show();
        });
    }
    BuildMobileBreadcrumbNav() {
        var html = '';
        var template = kendo.template($('#mobile-breadcrumb-template').html());
        $("#serviceBreadcrumb li:not([style*='display: none'])").each(function(index) {
            var li = $(this);
            var heading = li.attr('data-menuanchor').toLowerCase().replace('anchor', '');
            // skip confirmation step because we'll add an 'fa-check' for it after this loop
            if (heading === 'confirmation') return;
            // Evaluate CSS class
            var cssClass = '';
            if (li.hasClass('active')) cssClass = 'active';
            else if (li.hasClass('validated')) cssClass = 'validated';
            // Pass data to template
            var data = {
                index: index + 1,
                cssClass: cssClass,
                heading: heading
            };
            html += template(data);
        });
        html += "<li class='mobile-breadcrumb'><i class='fa fa-check'></i></li>";
        $('.mobile-breadcrumb-nav').empty().html(html);
        this.FormatMobileBreadcrumbNav();
    }
    RefreshMobileBreadcrumbNav() {
        $("#serviceBreadcrumb li:not([style*='display: none'])").each(function(index) {
            // Remove classes on our mobile breadcrumb
            var mobileBreadcrumb = $('.mobile-breadcrumb-nav li:nth-child(' + (index + 1) + ')');
            mobileBreadcrumb.removeClass('active');
            // Find out active class on main breadcrumb and set on mobile
            // breadcrumb
            var breadcrumb = $(this);
            if (breadcrumb.hasClass('active')) mobileBreadcrumb.addClass('active');
            else if (breadcrumb.hasClass('validated')) mobileBreadcrumb.addClass('validated');
        });
        this.FormatMobileBreadcrumbNav();
    }
    incrementBreadCrumbs(activeSection, nextSection) {
        $('[data-menuanchor="' + nextSection.anchor + '"]').addClass('active');
        $('[data-menuanchor="' + activeSection.anchor + '"]').removeClass('active').addClass('validated');
        this.RefreshMobileBreadcrumbNav();
    }
}
class $254a84bc556d8bd3$export$61b5e5bf1558fa5f {
    constructor(success, inputConcerned, errorMessage){
        this.success = success;
        this.input = inputConcerned;
        this.errorMessage = errorMessage;
    }
}
let $254a84bc556d8bd3$export$366dc4c52172531e = new $254a84bc556d8bd3$var$Utilities();



class $f736a2b71cdbd3b5$var$Common {
    static HideUserMessage() {
        $('#UserMessage').hide();
    }
    static ShowUserMessage(title, message, hidePanels) {
        if (hidePanels) $('#mainContent').hide();
        $('#UserMessage #UserMessage_Title').html(title);
        $('#UserMessage #UserMessage_Message').html(message);
        $('#UserMessage').show();
    }
    static ShowGenericError() {
        $('#ErrorDialog').kendoDialog({
            width: '450px',
            title: 'Error',
            closable: true,
            modal: false,
            content: 'Sorry, an error occured. Please try again or contact your dedicated Driverline for assistance'
        });
    }
    static GetExtraValidator() {
        var dropDownValid = true;
        var colour = $('#vehicle-colour-select');
        if (colour[0] !== null) {
            colour.parent().removeClass('k-invalid');
            if (colour.val() === '') {
                colour.parent().addClass('k-invalid');
                dropDownValid = false;
            }
        }
        var seats = $("#vehicle-number-of-seats-select");
        if (seats[0] !== null) {
            seats.parent().removeClass('k-invalid');
            if (seats.val() === '') {
                seats.parent().addClass('k-invalid');
                dropDownValid = false;
            }
        }
        var vehicleClass = $('#vehicle-class-select');
        if (vehicleClass[0] !== null) {
            vehicleClass.parent().removeClass('k-invalid');
            if (vehicleClass.val() === '') {
                vehicleClass.parent().addClass('k-invalid');
                dropDownValid = false;
            }
        }
        return dropDownValid;
    }
    static GetVehicleValidator() {
        return $('#Mileage').kendoValidator({
            rules: {
                minimumMileageRequired: function(input) {
                    var mileageSupplied = $('#Mileage').val().replace(/\,/g, '');
                    var currentMileage = $('#VehicleMileage').val();
                    var ConfirmMileageCheckBox = $('#ConfirmMileageCheckBox').is(':checked');
                    if (input.is('#Mileage')) {
                        if (parseInt(currentMileage) > parseInt(mileageSupplied) && !ConfirmMileageCheckBox) {
                            let msg = `The mileage provided is lower than the last reading (${currentMileage}). <br/>Check this box to confirm the mileage you have entered is correct, or re enter.`;
                            $('#ConfirmMileageCheckBox').next().addClass('k-checkbox-label').html(msg);
                            $('#ConfirmMileageContainer').removeClass('d-none').addClass('d-inline-block');
                            $('#vehicle-mileage').text(currentMileage);
                            return false;
                        } else if (!ConfirmMileageCheckBox) $('#ConfirmMileageContainer').removeClass('d-inline-block').addClass('d-none');
                        if (parseInt(mileageSupplied) > 2000000) {
                            let msg = `The provided mileage can not be higher than 2,000,000 miles!`;
                            $('#ConfirmMileageCheckBox').next().removeClass('k-checkbox-label').html(msg);
                            $('#ConfirmMileageContainer').removeClass('d-none').addClass('d-inline-block');
                            return false;
                        } else if (!ConfirmMileageCheckBox) $('#ConfirmMileageContainer').removeClass('d-inline-block').addClass('d-none');
                    }
                    return true;
                }
            },
            messages: {
                minimumMileageRequired: 'Invalid mileage. Must be greater than previous mileage.'
            }
        }).data('kendoValidator');
    }
    static BindValidationStyles(validator) {
        validator.bind("validate", function(e) {
            let $container = $(e.sender.element);
            let $invalidInputs = $container.find(".k-invalid");
            let validationManager = {
                _tooltipTemplate: `<div class="tooltip tooltip-error tooltip-checkbox" role="tooltip"><div class="arrow tooltip-arrow-error"></div><div class="tooltip-inner tooltip-inner-error"></div></div>`,
                _highlightLabel: (invalidInput)=>$(invalidInput).closest(".row").find("label:not(.k-radio-label)").addClass("error-label"),
                applyPrivacyCheckboxInputValidationStyle: (invalidInput)=>{
                    $(invalidInput).prop("data-toggle", "tooltip");
                    $(invalidInput).parent().find("label").addClass("privacy-checkbox-validation-label");
                    $(invalidInput).tooltip({
                        boundary: "body",
                        trigger: "manual",
                        placement: "auto",
                        template: validationManager._tooltipTemplate
                    });
                    $(invalidInput).tooltip("show");
                },
                applyLabelLessTextboxValidationStyle: (invalidInput)=>{
                    const errorMessage = $(invalidInput).parent().find('.k-tooltip-validation.k-invalid-msg').text();
                    if ($(invalidInput).parent().find(".error-icon-absolute").length === 0) {
                        let newElement = `<i class="fas fa-exclamation-circle error-icon-absolute" style="left: ${$(invalidInput).position().left + 15}px; top: ${$(invalidInput).position().top + 8}px;" data-toggle="tooltip" title="${errorMessage}" tabindex="-1"></i>`;
                        $(invalidInput).parent().append(newElement);
                        $('[data-toggle="tooltip"]').tooltip({
                            boundary: "body",
                            trigger: "focus",
                            placement: "auto",
                            template: validationManager._tooltipTemplate
                        });
                        (0, $254a84bc556d8bd3$export$8e0397c03d8b0af5).set(invalidInput, $(invalidInput).prop("placeholder"));
                        $(invalidInput).removeAttr("placeholder");
                    }
                },
                applyGenericValidationStyle: (invalidInput)=>{
                    const errorMessage = $(invalidInput).closest(".row.form-group").find(".k-tooltip-validation.k-invalid-msg").text();
                    const newElement = `<i class="fas fa-exclamation-circle error-icon" data-toggle="tooltip" title="${errorMessage}" tabindex="-1"></i>`;
                    if ($(invalidInput).closest(".row.form-group").find(".error-icon").length === 0) {
                        validationManager._highlightLabel(invalidInput);
                        $(invalidInput).closest(".row.form-group").find("label:not(.k-radio-label)").append(newElement);
                        $('[data-toggle="tooltip"]').tooltip({
                            boundary: "body",
                            trigger: "focus",
                            placement: "auto",
                            template: validationManager._tooltipTemplate
                        });
                        if ($(invalidInput).is(':radio')) $(invalidInput).closest(".row.form-group").find(".k-radio-label").addClass("error-radio-btn-label");
                    }
                },
                applyWheelplanPanelValidation: (invalidPanel)=>{
                    let newElement = `<i class="fas fa-exclamation-circle error-icon-absolute" style="left: 30px; top: 15px;" data-toggle="tooltip" title="${$(invalidPanel).parent().find('.k-tooltip-validation.k-invalid-msg').text()}" tabindex="-1"></i>`;
                    $(invalidPanel).parent().append(newElement);
                    $('[data-toggle="tooltip"]').tooltip({
                        boundary: "body",
                        trigger: "focus",
                        placement: "auto",
                        template: validationManager._tooltipTemplate
                    });
                },
                applyBtnValidationStyle: (invalidInput)=>{
                    const $btn = $(invalidInput).parent().find(".btn-to-validate");
                    const errorMessage = $(invalidInput).parent().find(".k-invalid-msg").text();
                    const newElement = `<i class="fas fa-exclamation-circle error-icon" data-toggle="tooltip" title="${errorMessage}" tabindex="-1"></i>`;
                    $btn.before(newElement);
                    $('[data-toggle="tooltip"]').tooltip({
                        boundary: "body",
                        trigger: "focus",
                        placement: "auto",
                        template: validationManager._tooltipTemplate
                    });
                }
            };
            if ($container.is('[id^="wheelPlanSection"]')) validationManager.applyWheelplanPanelValidation($container.find('.tyreDetailInvalid'));
            else if ($invalidInputs) $invalidInputs.each((index, invalidInput)=>{
                if (!$invalidInputs.hasClass('noValidationStyle')) {
                    // Making sure the input is not hidden
                    let isHidden = $(invalidInput).is(':hidden');
                    let isDropDownList = $(invalidInput).data("role") === "dropdownlist";
                    if (!isHidden || isHidden && isDropDownList) {
                        // check if input is single checkbox
                        if ($(invalidInput).hasClass('privacyCheckboxValidation')) validationManager.applyPrivacyCheckboxInputValidationStyle(invalidInput);
                        else // check if input is textbox and without label, if so apply icon within
                        if ($(invalidInput).is('input:text') && $(invalidInput).data('role') !== 'dropdownlist' && ($(invalidInput).closest('.row.form-group').length === 0 || $(invalidInput).closest('.form-group.row').find('label:not(.k-radio-label)').length === 0)) validationManager.applyLabelLessTextboxValidationStyle(invalidInput);
                        else if (isDropDownList) {
                            validationManager.applyGenericValidationStyle(invalidInput);
                            $(invalidInput).prevAll().closest(".k-dropdown-wrap").addClass('invalid-border');
                        } else // for everything else apply generic styles
                        validationManager.applyGenericValidationStyle(invalidInput);
                    } else if ($(invalidInput).hasClass('btn-validation-input')) validationManager.applyBtnValidationStyle(invalidInput);
                }
            });
        });
    }
    static RemoveValidationStyles(input, panel) {
        if (input) {
            const removeHighlightLabel = (invalidInput)=>$(invalidInput).closest('.row.form-group').find('label').removeClass('error-label');
            const removeErrorIcon = (invalidInput)=>$(invalidInput).closest('.row.form-group').find('label').find('.error-icon').remove();
            const removeErrorIconOnBtn = (invalidHiddenInput)=>$(invalidHiddenInput).parent().find('.error-icon').remove();
            const removeInputErrorIcon = (invalidInput)=>{
                const errorIconEl = $(invalidInput).parent().find('.error-icon-absolute');
                if (errorIconEl.length !== 0) {
                    errorIconEl.remove();
                    if ((0, $254a84bc556d8bd3$export$8e0397c03d8b0af5).has(input)) {
                        (0, $254a84bc556d8bd3$export$8e0397c03d8b0af5).get(input);
                        $(input).attr('placeholder', (0, $254a84bc556d8bd3$export$8e0397c03d8b0af5).get(input));
                        (0, $254a84bc556d8bd3$export$8e0397c03d8b0af5).delete(input);
                    }
                }
            };
            const removeKendoHighlight = (invalidInput)=>$(invalidInput).removeClass('k-invalid');
            const removePrivacyCheckboxValidationStyles = (invalidInput)=>{
                $(invalidInput).removeAttr('data-toggle');
                $(invalidInput).parent().find('label').removeClass('privacy-checkbox-validation-label');
            };
            if ($(input).prop('data-toggle') === 'tooltip') // dispose of a tooltip when applied to the DOM Element itself.
            $(input).tooltip('dispose');
            else // dispose of a tooltip when applied to the DOM Element parent.
            $(input).closest('.row').find('[data-toggle="tooltip"]').tooltip('dispose');
            if ($(input).hasClass('privacyCheckboxValidation')) removePrivacyCheckboxValidationStyles(input);
            else if ($(input).hasClass('noLabelValidation')) removeInputErrorIcon(input);
            else {
                removeHighlightLabel(input);
                removeErrorIcon(input);
                removeErrorIconOnBtn(input);
                removeKendoHighlight(input);
                let isDropDownList = $(input).data("role") === "dropdownlist";
                if ($(input).is(':radio')) $(input).closest('.row.form-group').find('.k-radio-label').removeClass('error-radio-btn-label');
                else if (isDropDownList) $(input).prevAll().closest(".k-dropdown-wrap").removeClass('invalid-border');
            }
        } else if (panel && panel.length > 0) {
            $(panel).find('[data-toggle="tooltip"]').tooltip('dispose');
            $(panel).find('.error-icon-absolute').remove();
            $(panel).find('.tyreDetailInvalid').removeClass('tyreDetailInvalid');
        }
    }
    static Bounce(element, times, distance, speed) {
        for(var i = 0; i < times; i++)element.animate({
            marginTop: '-=' + distance
        }, speed).animate({
            marginTop: '+=' + distance
        }, speed);
    }
    static InitialiseEmailSupportTab() {
        $('#email-tab').click(()=>{
            $("#help-form").detach().appendTo('#email-container');
            $('#email-container').toggle('slide');
        });
        $('#supportModalBtn').click(()=>{
            $("#help-form").detach().appendTo('#mobile-email-container');
            $('#emailModal').toggle('slide');
        });
        if ($('#fullPageContainer[data-formName="VE103"]').length) $('#supportModalBtn').removeClass('d-none').show();
        [
            $('#supportLargeScreenForm'),
            $('#supportSmallScreenForm')
        ].forEach((form)=>{
            form.on('submit', (event)=>{
                if (event.target.checkValidity() === false) {
                    event.preventDefault();
                    event.stopPropagation();
                } else {
                    let driverData = null;
                    let endpoint = null;
                    let $formContainer = $(event.target).closest('.form');
                    $formContainer.find('#sendSupportEmail').prop('disabled', true);
                    let formData = {
                        fullname: $formContainer.find('#user-name').val(),
                        email: $formContainer.find('#user-email').val(),
                        phone: $formContainer.find('#user-phone').val(),
                        note: $formContainer.find('#user-note').val()
                    };
                    let formName = $('#fullPageContainer').attr('data-formName');
                    switch(formName){
                        case 'VE103':
                            driverData = (0, $f90b7548d54d161a$export$76b090c025b4ff78).model;
                            endpoint = '/foreigntravel/SendSupportEmail';
                            break;
                        default:
                            driverData = null;
                            break;
                    }
                    let data = {
                        'driverData': driverData,
                        'formData': formData
                    };
                    $.ajax({
                        type: 'POST',
                        url: endpoint,
                        data: data,
                        success: function() {
                            $('#email-container, #emailModal').find('#confirmationMessage').show(), setTimeout(function() {
                                $('#email-container, #emailModal').find('#confirmationMessage').fadeOut();
                                $('#email-container, #emailModal').toggle('slide').find('textarea').val('');
                                $('.modal-backdrop, #emailModal').hide();
                            }, 3000);
                        },
                        error: ()=>console.log('error sending email.')
                    });
                }
                event.target.classList.add('was-validated');
                event.preventDefault();
            });
        });
    }
    static GetQueryStringValue(key, url) {
        if (!url) url = window.location.href;
        key = key.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + key + '(=([^&#]*)|&|#|$)'), results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
}
var $f736a2b71cdbd3b5$export$2e2bcd8739ae039 = $f736a2b71cdbd3b5$var$Common;
$(document).ready(function() {
    if (LAYOUT_MODE == 'mode2') $('#breadcrumb').detach().prependTo('#mainContent');
    $('body').removeClass('d-none');
    $('.tip').tooltip({
        boundary: "body",
        trigger: "focus",
        placement: "auto"
    });
    $(document).on('focus focusout click', 'input.k-invalid', (event)=>$f736a2b71cdbd3b5$var$Common.RemoveValidationStyles(event.target));
    $(document).on('change', '.k-dropdown', (event)=>$f736a2b71cdbd3b5$var$Common.RemoveValidationStyles(event.target));
    $(document).on('click', '.btn', (event)=>$f736a2b71cdbd3b5$var$Common.RemoveValidationStyles(event.target));
    document.documentElement.style.setProperty('--customer-font-family', SITE_FONT_FAMILY);
    document.documentElement.style.setProperty('--customer-color', SITE_COLOR);
    document.documentElement.style.setProperty('--customer-sub-color', SITE_COLOR2);
    document.documentElement.style.setProperty('--customer-color-gradient1', SITE_COLOR_GRADIENT_1);
    document.documentElement.style.setProperty('--customer-color-gradient2', SITE_COLOR_GRADIENT_2);
    document.documentElement.style.setProperty('--customer-color-gradient3', SITE_COLOR_GRADIENT_3);
    document.documentElement.style.setProperty('--customer-color-gradient4', SITE_COLOR_GRADIENT_4);
    document.documentElement.style.setProperty('--customer-header-bar-style', SITE_HEADER_BAR_STYLE);
    document.documentElement.style.setProperty('--customer-header-row-style', SITE_HEADER_ROW_STYLE);
    if (SITE_TITLE_BAR_COLOR_USE_GRADIENT.toUpperCase() === 'TRUE') {
        document.documentElement.style.setProperty('--customer-title-bar-color-gradient1', SITE_COLOR_GRADIENT_1);
        document.documentElement.style.setProperty('--customer-title-bar-color-gradient2', SITE_COLOR_GRADIENT_2);
        document.documentElement.style.setProperty('--customer-title-bar-color-gradient3', SITE_COLOR_GRADIENT_3);
        document.documentElement.style.setProperty('--customer-title-bar-color-gradient4', SITE_COLOR_GRADIENT_4);
    } else {
        document.documentElement.style.setProperty('--customer-title-bar-color-gradient1', SITE_COLOR);
        document.documentElement.style.setProperty('--customer-title-bar-color-gradient2', SITE_COLOR);
        document.documentElement.style.setProperty('--customer-title-bar-color-gradient3', SITE_COLOR);
        document.documentElement.style.setProperty('--customer-title-bar-color-gradient4', SITE_COLOR);
    }
    $('.view-privacy-policy').on('click', (event)=>{
        $('#privacyPolicy').toggleClass('d-none');
    });
});





class $0f9b377c2aa86abc$var$Address {
    constructor(){
        this.ElementID = null;
    }
    // Built to only have one address visible on the page at once
    // Call setup after you make your address visible to the user
    Setup(AddressListElementID, UniqueReference, LogDescription) {
        let _this = this;
        let container = new ContainingElement(UniqueReference);
        var $buttonSelector = $('#' + container.ElementID + 'ButtonPostCodeLookup');
        $buttonSelector.unbind('click');
        $buttonSelector.click(function() {
            _this.Search(AddressListElementID, LogDescription, container.ElementID);
        });
        $buttonSelector.trigger('click');
    }
    GetAddressList(PostCode, RequestVerificationToken, Logdescription) {
        var result = $.Deferred();
        $.ajax({
            url: '/address/addresslist',
            type: 'POST',
            data: {
                postcode: PostCode,
                __RequestVerificationToken: RequestVerificationToken,
                LogDescription: Logdescription
            },
            cache: true,
            success: function(data) {
                result.resolve(data);
            },
            error: function(xhr, ajaxOptions, thrownError) {},
            complete: function(data) {}
        });
        return result.promise();
    }
    GetCoordinates(postcode, requestVerificationToken, logDescription) {
        return new Promise(function(resolve, reject) {
            $.ajax({
                url: '/address/coordinates',
                type: 'POST',
                data: {
                    postcode: postcode,
                    __RequestVerificationToken: requestVerificationToken,
                    logDescription: logDescription
                },
                cache: true,
                success: function(data) {
                    resolve(data);
                },
                error: function(xhr, ajaxOptions, thrownError) {
                    reject(thrownError);
                },
                complete: function(data) {}
            });
        });
    }
    GetPostCodeAddress(Key, RequestVerificationToken, VehicleRegistration) {
        var result = $.Deferred();
        $.ajax({
            url: '/address/PostCodeAddress',
            type: 'POST',
            data: {
                key: Key,
                __RequestVerificationToken: RequestVerificationToken,
                vehicleRegistration: VehicleRegistration
            },
            cache: true,
            success: function(data) {
                result.resolve(data);
            },
            error: function(xhr, ajaxOptions, thrownError) {},
            complete: function(data) {}
        });
        return result.promise();
    }
    Search(addressListElementID, logDescription, containerElementID) {
        let _this = this;
        var addressHTML = '';
        var postcode = $('#' + containerElementID + 'Postcode').val().toLocaleUpperCase();
        $('#' + containerElementID + 'Postcode').val(postcode);
        if (!postcode) {
            $('#' + containerElementID + 'Postcode').addClass('k-invalid');
            return;
        } else $('#' + containerElementID + 'Postcode').removeClass('k-invalid');
        var addresses = this.GetAddressList(postcode, $('input[name=__RequestVerificationToken]').val(), logDescription);
        $.when(addresses).done(function(l_addresses) {
            if (l_addresses.length > 0) {
                addressHTML += '<ul class="pl-0" style="list-style-type:none;">';
                $.each(l_addresses, function(Id, address) {
                    var displayText = '';
                    if (address.property.length > 0) displayText = address.property + ', ';
                    if (address.organisation.length > 0) displayText += address.organisation + ', ';
                    if (address.street.length > 0) displayText += address.street + ', ';
                    if (address.town.length > 0) displayText += address.town;
                    addressHTML += '<li><a href="#" class=\"address-list-item\" data-organisation=\"' + address.organisation + '\" data-property=\"' + address.property + '\" data-street=\"' + address.street + '\" data-locality=\"' + address.locality + '\" data-town=\"' + address.town + '\" data-postalcounty=\"' + address.postalCounty + '\" data-postcode=\"' + address.postcode + '\"><span class=\"fas fa-home\" style=\"margin-right:10px;\"></span>' + displayText + '</li>';
                });
                addressHTML += '</ul>';
            } else {
                addressHTML += "<p>We're sorry but we cannot find the postcode <strong>" + postcode + "</strong>. If that is the correct postcode, please call your driverline for further assistance.</p>";
                addressHTML += '<div class="form-group row mt-3" ><div class="col-md-10"><button class="btn btn-outline-dark" style="width:280px;">Go Back</button></div></div>';
            }
            $('#' + containerElementID + 'AddressList').html('').html(addressHTML).css('height', $('#' + containerElementID).height() + 'px');
            $('#' + containerElementID + 'AddressList').find('.address-list-item').each(function(index, element) {
                $(element).on('click', function(event) {
                    event.preventDefault();
                    _this.PopulateAddress(this, addressListElementID, containerElementID);
                });
            });
            $('#' + containerElementID + 'AddressList').find('.btn-outline-dark').each(function(index, element) {
                $(element).on('click', function() {
                    _this.SlideBack(containerElementID);
                });
            });
            $('#' + containerElementID).animate({
                marginLeft: '-1500px'
            }, 500, function() {
                $('#' + containerElementID + 'AddressList').animate({
                    marginRight: '0px'
                }, 500, function() {
                // Animation complete.
                });
            });
        });
    }
    PopulateAddress(addressElement, addressListElementID, containerElement) {
        this.SlideBack(containerElement);
        let street = $(addressElement).data('property') ? `${$(addressElement).data('property')}, ${$(addressElement).data('street')}` : $(addressElement).data('street');
        let address = {
            addressLine1Input: $('#' + containerElement).find('#' + containerElement + 'Address_AddressLine1'),
            addressLine2Input: $('#' + containerElement).find('#' + containerElement + 'Address_AddressLine2'),
            addressTown: $('#' + containerElement).find('#' + containerElement + 'Address_Town'),
            addressCounty: $('#' + containerElement).find('#' + containerElement + 'Address_County'),
            addressPostCode: $('#' + containerElement).find('#' + containerElement + 'Address_Postcode')
        };
        for(let prop in address){
            $(address[prop]).val('');
            (0, $f736a2b71cdbd3b5$export$2e2bcd8739ae039).RemoveValidationStyles(address[prop]);
        }
        if ($(addressElement).data('organisation')) {
            address.addressLine1Input.val($(addressElement).data('organisation'));
            address.addressLine2Input.val(street);
        } else address.addressLine1Input.val(street);
        address.addressTown.val($(addressElement).data('town'));
        address.addressCounty.val($(addressElement).data('postalcounty'));
        address.addressPostCode.val($(addressElement).data('postcode'));
    }
    BindControls() {
        let _this = this;
        $('.buttonPostCodeLookup').on('click', function() {
            var containerId = $(this).parents('.addressContainer').prop('id').replace(' ', '');
            _this.Search('PostCodeLookupDialog', '', containerId);
        });
    }
    SlideBack(containerElement) {
        $('#' + containerElement + 'AddressList').animate({
            marginRight: '-1500px'
        }, 500, function() {
            $('#' + containerElement).animate({
                marginLeft: '0px'
            }, 500, function() {
                $('#' + containerElement + 'AddressList').html('');
            });
        });
    }
    ContainingElement(elementID) {
        this.ElementID = elementID;
    }
}
let $0f9b377c2aa86abc$export$f5c65d7eccbf77d4 = new $0f9b377c2aa86abc$var$Address();


//import kendo from '@progress/kendo-ui';

class $1ab168822f4abc32$var$Mapping {
    constructor(){
        this.green = '#00C800';
        this.blue = '#4472c4';
        this.selectedDepotId = null;
        this.map = null;
        this.infobox = null;
        this.depots = [];
        this.debug = false;
        this.manufacturerId = 0;
        this.serviceId = 0;
        this.level = 1;
        this.tier = 1;
        this.postcode = null;
        this.serviceType = null;
        this.customerId = null;
    }
    ResetState() {
        $('#grid').html('');
        $('#map').html('');
        this.selectedDepotId = null;
        this.map = null;
        this.infobox = null;
        this.depots = [];
        this.manufacturerId = 0;
        this.serviceId = 0;
        this.postcode = null;
    }
    SetManufacturerId(manufacturerId) {
        this.manufacturerId = manufacturerId;
    }
    SetServiceType(serviceType) {
        this.serviceType = serviceType;
    }
    SetCustomerId(customerId) {
        this.customerId = customerId;
    }
    GetPostcodeCoordinates() {
        kendo.ui.progress($("body"), true);
        let _this = this;
        if (this.postcode != $('#jobPostcode').val()) {
            this.ResetState();
            this.postcode = $('#jobPostcode').val();
            var coordinatesRequest = (0, $0f9b377c2aa86abc$export$f5c65d7eccbf77d4).GetCoordinates(this.postcode, $('input[name=__RequestVerificationToken]').val(), '');
            $.when(coordinatesRequest).then(function(coordinates) {
                _this.coordinates = coordinates;
                _this.RefreshMap(coordinates);
                var depotsRequest = _this.GetDepotList(coordinates.latitude, coordinates.longitude);
                $.when(depotsRequest).then(function(response) {
                    _this.depots = response;
                    var clusterDepots = false;
                    _this.PlotDepots(clusterDepots);
                    _this.RefreshDepotList();
                    kendo.ui.progress($("body"), false);
                });
            });
        } else kendo.ui.progress($("body"), false);
    }
    RefreshMap(coords) {
        let _this = this;
        if (!coords) coords = _this.coordinates;
        // Create map
        var jobLocation = new Microsoft.Maps.Location(coords.latitude, coords.longitude);
        _this.map = new Microsoft.Maps.Map(document.getElementById('map'), {
            center: jobLocation,
            zoom: 12
        });
        // Create an infobox for depot information. This is hidden by default, and
        // populated and displayed when a pushpin is selected
        _this.infobox = new Microsoft.Maps.Infobox(_this.map.getCenter(), {
            visible: false,
            autoAlignment: true
        });
        _this.infobox.setMap(_this.map);
        // Draw proximity circles
        Microsoft.Maps.loadModule('Microsoft.Maps.SpatialMath', function() {
            // Inner circle
            var greenFill = new Microsoft.Maps.Color(0.1, 0, 200, 0);
            var greenStroke = new Microsoft.Maps.Color(1, 0, 200, 0);
            _this.DrawMapCircle(jobLocation, 5, greenFill, greenStroke);
            // Outer circle
            var blueFill = new Microsoft.Maps.Color(0, 0, 0, 200);
            var blueStroke = new Microsoft.Maps.Color(1, 0, 0, 200);
            _this.DrawMapCircle(jobLocation, 10, blueFill, blueStroke);
            // Add a pushpin at the user's location.
            var pin = new Microsoft.Maps.Pushpin(jobLocation);
            _this.map.entities.push(pin);
        });
    }
}
let $1ab168822f4abc32$export$9d1417450875059f = new $1ab168822f4abc32$var$Mapping();


class $3a1136aee2ee508e$var$VE103 {
    constructor(){
        // Anchors
        this.vehicleSearchAnchor = "VehicleSearchAnchor";
        this.vehicleAnchor = "VehicleAnchor";
        this.ve103Anchor = "VE103Anchor";
        this.driverAnchor = "DriverAnchor";
        this.driverAddressAnchor = "DriverAddressAnchor";
        this.summaryAnchor = "SummaryAnchor";
        this.postageAnchor = "PostageAnchor";
        this.ve103InfoPage1Anchor = 've103InfoPage1Anchor';
        this.ve103InfoPage2Anchor = 've103InfoPage2Anchor';
        this.travelkitsAnchor = "TravelKitsAnchor";
        // Navigation Text
        this.vehicleSearchNavigationText = "Vehicle Search";
        this.vehicleNavigationText = "Vehicle Details";
        this.ve103NavigationText = "Travel Dates";
        this.driverNavigationText = "Driver Details";
        this.driverAddressNavigationText = "Driver Address";
        this.summaryNavigationText = "Summary";
        this.postageNavigationText = "Delivery";
        this.ve103InfoPage1Text = 'Info';
        this.ve103InfoPage2Text = 'Info2';
        this.travelkitsNavigationText = "Travel Kits";
        this.viewModel = null;
        this.vehicle = null;
        this.clicked = false;
        this.createCertificatePressed = false;
        this.returnToSummary = false;
        this.orderTotal = 0;
        this.postageOptions = {};
        this.postageServiceId = null;
        this.postageService = null;
        this.useDeliveryAddress = false;
        this.useInvoiceAddress = false;
        this.certificateReference = null;
        this.doBounce = null;
        this.utilities = (0, $254a84bc556d8bd3$export$366dc4c52172531e);
        this.numOfDrivers = 1;
        this.vehicleSearchDetails = "VehicleSearchDetails";
        this.vehicleDetails = "VehicleDetails";
        this.ve103Details = "VE103Details";
        this.travelkits = "TravelKits";
        this.driverDetails = "DriverDetails";
        this.driverAddressDetails = "DriverAddressDetails";
        this.summaryDetails = "SummaryDetails";
        this.postageDetails = "PostageDetails";
        this.paymentDetails = "PaymentDetails";
        this.confirmation = "Confirmation";
        this.currentStage = this.vehicleDetails;
        this.ve103InfoPage1Details = 've103InfoPage1Details';
        this.ve103InfoPage2Details = 've103InfoPage2Details';
        this.stages = [
            this.vehicleSearchDetails,
            this.vehicleDetails,
            this.ve103InfoPage1Details,
            this.ve103InfoPage2Details,
            this.ve103Details,
            this.travelkits,
            this.driverDetails,
            this.driverAddressDetails,
            this.postageDetails,
            this.summaryDetails,
            this.paymentDetails
        ];
        this.anchors = [
            this.vehicleSearchAnchor,
            this.vehicleAnchor,
            this.ve103InfoPage1Anchor,
            this.ve103InfoPage2Anchor,
            this.ve103Anchor,
            this.travelkitsAnchor,
            this.driverAnchor,
            this.driverAddressAnchor,
            this.postageAnchor,
            this.summaryAnchor
        ];
        this.navigationTexts = [
            this.vehicleSearchNavigationText,
            this.ve103InfoPage1Text,
            this.ve103InfoPage2Text,
            this.vehicleNavigationText,
            this.ve103NavigationText,
            this.travelkitsNavigationText,
            this.driverNavigationText,
            this.driverAddressNavigationText,
            this.postageNavigationText,
            this.summaryNavigationText
        ];
        this.model = null;
        kendo.culture("en-GB");
        this.BindFormControls();
        $("#fullPageContainer").show();
        $("#breadcrumb, #mobileBreadcrumbNav").removeClass('d-none');
    }
    SetVehicle(vehicleIn) {
        let _this = this;
        _this.vehicle = _this.model = vehicleIn;
    }
    Initialise() {
        let _this = this;
        gtag('event', 'entered', {
            'event_category': 'section',
            'event_label': '1: FT - entered registration'
        });
        var viewModelRequest = _this.GetViewModel();
        $.when(viewModelRequest).done(function(model) {
            _this.viewModel = model;
            if (model.hpi !== null && model.errors.length == 0) {
                $("#HpiExRegNo").text(model.hpi.exRegNo);
                $("#HpiExMake").text(model.hpi.exMake);
                $("#HpiExModel").text(model.hpi.exModel);
                $("#HpiExFirstRegDate").text(kendo.toString(new Date(model.hpi.exFirstRegDate), "dd/MM/yyyy"));
                //REMOVE FROM API - TODO
                //$("#vehicle-driver-company").text(_this.vehicle.driverCompanyName);
                //$("#vehicle-lease-company").text(_this.vehicle.customerName);
                if (model.hpi.exColour) $("#vehicle-colour").html(`<span id="HpiExColour">${model.hpi.exColour}</span>`);
                else {
                    $("#vehicle-colour").append('<select id="vehicle-colour-select"></select>');
                    var colourSelect = $("#vehicle-colour-select").append($("<option />").text("Please choose...").val(""));
                    $.each(model.colours, function() {
                        colourSelect.append($("<option />").text(this).val(this));
                    });
                    $(colourSelect).kendoDropDownList();
                }
                if (model.hpi.exSeating) $("#vehicle-number-of-seats").html(`<span id="HpiexSeating">${model.hpi.exSeating}</span>`);
                else {
                    $("#vehicle-number-of-seats").append('<select id="vehicle-number-of-seats-select"></select>');
                    var seatingSelect = $("#vehicle-number-of-seats-select").append($("<option />").text("Please choose...").val(""));
                    for(var i = 1; i <= 20; i++)seatingSelect.append($("<option />").text(i).val(i));
                    $(seatingSelect).kendoDropDownList();
                }
                if (model.vehicle.class) $("#vehicle-class").html(`<span id="vehicleClass">${model.vehicle.class}</span>`);
                else {
                    $("#vehicle-class").append('<select id="vehicle-class-select"></select>');
                    var classSelect = $("#vehicle-class-select").append($("<option />").text("Please choose...").val(""));
                    $.each(model.vehicleTypes, function() {
                        classSelect.append($("<option />").text(this).val(this));
                    });
                    $(classSelect).kendoDropDownList();
                }
                var cost = model.vE103Cost;
                if (cost || cost === 0) $("#VE103Cost").text(`\xa3${cost.toFixed(2)}`);
                else $("#VE103Cost").text("");
                $("#postage-options").html("");
                _this.postageOptions = model.postageOptions;
                var postageCostSet = false;
                $.each(model.postageOptions, function() {
                    var includesAdminFee = '';
                    const emptyCost = "\xa30.00";
                    var cost = this.price;
                    if (this.description.substring(0, 2) === '* ') {
                        if (cost == emptyCost) cost = '';
                        else {
                            postageCostSet = true;
                            includesAdminFee = '*';
                        }
                        this.description = this.description.substring(2);
                    } else {
                        // assumes paid for postage items are above
                        if (!postageCostSet) {
                            if (cost == emptyCost) cost = '';
                        }
                    }
                    $("#postage-options").prepend(`<div style="padding-bottom:0.5em;">${`<input type="radio" name="Postage" id="Postage${this.id}" value="${this.id}" class="k-radio" required validationMessage="Select a postage option" />`}${`<label class="k-radio-label" for="Postage${this.id}">${this.description} ${cost} ${includesAdminFee}</label>`}</div>`);
                });
                if (!postageCostSet) $('#admin-fee').addClass('d-none');
                $("#postage-options").append('<span class="k-invalid-msg" data-for="Postage"></span>');
                $("#postage-options").change(function() {
                    _this.SetNextButtonText();
                });
                $("#PaymentForm").prop("action", model.worldPayURL);
                if (model.worldPayTestMode) $("#PaymentForm").append('<input type="hidden" name="testMode" value="100" />');
                $("#VehicleID").val(model.vehicle.id);
                $('#VehicleMileage').val(model.vehicle.mileage);
                $("#Registration").val(model.vehicle.registration);
                $("#CertificateCost").val(model.vE103Cost);
                if (model.vehicle.businessUse === 'Y') $("#AskBusinessUse").removeClass('d-none');
                (0, $254a84bc556d8bd3$export$366dc4c52172531e).LoadHtmlTemplate('/ForeignTravel/GetEmailForm', {}, async function(template) {
                    $('#email-helper').html(template);
                    (0, $f736a2b71cdbd3b5$export$2e2bcd8739ae039).InitialiseEmailSupportTab();
                });
                _this.ShowStage(_this.stages[1], true);
            } else if (model.errors.length > 0) (0, $f736a2b71cdbd3b5$export$2e2bcd8739ae039).ShowUserMessage(model.errors[0].errorTitle, model.errors[0].errorText, true);
            // Set Travel Kit Details
            if (model.travelKit !== null && model.errors.length == 0) {
                var products = [
                    {
                        id: 1,
                        name: model.travelKit.product1Name,
                        cost: model.travelKit.product1Cost,
                        description: model.travelKit.product1Description,
                        sku: model.travelKit.product1SKU,
                        initialUnits: 0
                    },
                    {
                        id: 2,
                        name: model.travelKit.product2Name,
                        cost: model.travelKit.product2Cost,
                        description: model.travelKit.product2Description,
                        sku: model.travelKit.product2SKU,
                        initialUnits: 0
                    },
                    {
                        id: 3,
                        name: model.travelKit.product3Name,
                        cost: model.travelKit.product3Cost,
                        description: model.travelKit.product3Description,
                        sku: model.travelKit.product3SKU,
                        initialUnits: 0
                    }
                ];
                products.forEach(function(product) {
                    var productHTML = `
							<div class="row smallTitle">
								<p id="TravelKitProduct${product.id}Name" style="text-decoration: underline;">${product.name}</p>
								<p>- \xa3<span id="TravelKitProduct${product.id}Cost">${product.cost}</span></p>
							</div>
							<div class="ml-4">
								<div class="row">
									<p id="TravelKitProduct${product.id}Description">${product.description}</p>
								</div>
								<div class="row align-items-center mb-2">
									<div class="col-auto">
										<span class="col-form-label">How many</span>
									</div>
									<div class="col-auto">
										<input class="mx-2 product-total-units" id="TravelKitProduct${product.id}Units" name="TravelKitProduct${product.id}Units" type="text" />
									</div>
									<div class="col-auto">
										<span class="col-form-label">Cost:</span>
									</div>
									<div class="col-auto">
										<span>\xa3</span><span id="TravelKitProduct${product.id}TotalCost" class="product-total-cost${product.id}"></span>
									</div>
								</div>
							</div>
						`;
                    // Append the generated HTML to the container
                    $('#travelkit-container').append(productHTML);
                    // Initialize Kendo dropdown for each product
                    $(`#TravelKitProduct${product.id}Units`).kendoDropDownList({
                        dataSource: [
                            0,
                            1,
                            2,
                            3,
                            4,
                            5
                        ],
                        change: function() {
                            var selectedUnits = this.value();
                            var totalCost = selectedUnits * product.cost;
                            $(`#TravelKitProduct${product.id}TotalCost`).text(totalCost.toFixed(2));
                            // Recalculate overall total cost
                            _this.UpdateOverallTotal(model.travelKit.deliveryCost);
                        }
                    }).data("kendoDropDownList").wrapper.css("width", "50px");
                    // Set initial product cost to £0.00
                    $(`#TravelKitProduct${product.id}TotalCost`).text("0.00");
                });
                // Set the initial total cost to 0
                $("#TravelKitTotalCost").text("Total Price: \xa30.00");
                $("#TravelKitWarningText").text(model.travelKit.warningText);
                $("#TravelKitDeliveryCost").text("There is a \xa3" + model.travelKit.deliveryCost + " delivery charge per item");
            }
            kendo.ui.progress($("body"), false);
        });
    }
    SumTravelKits = (deliveryCost)=>{
        var overallTotal = 0;
        for(var i = 0; i++, i <= 3;){
            var itemTotal = 0;
            $(".product-total-cost" + i).each(function() {
                itemTotal += parseFloat($(this).text()) || 0; // Convert to float and add
            });
            if (itemTotal > 0) overallTotal += itemTotal + deliveryCost;
        }
        return overallTotal;
    };
    // Function to calculate and update total price
    UpdateOverallTotal(deliveryCost) {
        var overallTotal = this.SumTravelKits(deliveryCost);
        $("#TravelKitTotalCost").text(`Total Price: \xa3${overallTotal.toFixed(2)}`);
    }
    BindFormControls() {
        let _this = this;
        $.each(_this.anchors, function(index, value) {
            var listItem;
            listItem = `<li data-menuanchor='${value}'>`;
            listItem += `<a href='#${value}'>`;
            listItem += `<div class='d-md-none d-lg-none'>${parseInt(parseInt(index) + 1)}</div>`;
            listItem += `<div class='d-none d-md-block text-center'>${_this.navigationTexts[index]}</div>`;
            listItem += "</a>";
            listItem += "</li>";
            $("#serviceBreadcrumb").append(listItem);
        });
        // Postage
        $("input[type=radio][name=Postage]").change(function() {
            _this.SetNextButtonText();
        });
        // Main Driver (Driver 1 of 3)
        $("#ButtonBackToMainDriver").click(function() {
            $('[data-toggle="tooltip"]').tooltip('hide');
            _this.DisplayStage(_this.driverDetails, 0);
            $("#AdditionalDriver1").delay(500).hide();
            $("#ButtonUseAdditionalDriverOne").closest(".row").show();
        });
        $("#ButtonBackToAdditionalDriverOne").click(function() {
            $('[data-toggle="tooltip"]').tooltip('hide');
            $("#AdditionalDriver2").hide();
            _this.DisplayStage(_this.driverDetails, 1);
        });
        $(".driver-next-button").click(function() {
            const validator = _this.BindValidation($(".slide:visible").attr("id"));
            validator.hideMessages();
            if (validator.validate()) {
                var activeSlide = _this.GetActiveSlide();
                $(".slide").hide();
                var activeSlideIndex = activeSlide.Index;
                if (_this.numOfDrivers > 1 && activeSlideIndex < _this.numOfDrivers - 1) _this.ShowStage(_this.driverDetails, false, activeSlideIndex + 1);
                else if (LAYOUT_MODE == 'mode2') _this.Navigate(_this.driverAddressDetails);
                else $("#DataProtectionSlide").show();
            }
        });
        // Additional Driver 1 (Driver 2 of 3)
        $("#AdditionalDriver1").hide();
        $("#ButtonUseAdditionalDriverOne").click(function() {
            var validator = _this.BindValidation($(".slide:visible").attr("id"));
            if (validator.validate()) {
                $("#MainDriver").hide();
                $("#AdditionalDriver1").show();
                _this.DisplayStage(_this.driverDetails, 1);
                $('#Driver_Additional1Title, #Driver_Additional1FirstName, #Driver_Additional1Surname').attr('required', 'required');
                _this.numOfDrivers = 2;
                $("#ButtonUseAdditionalDriverOne").closest(".row").hide();
            }
        });
        $("#ButtonDoNotUseAdditionalDriverOne").click(function() {
            var validator = _this.BindValidation($(".slide:visible").attr("id"));
            validator.hideMessages();
            _this.DisplayStage(_this.driverDetails, 0);
            $("#AdditionalDriver1").delay(500).hide();
            _this.numOfDrivers = 1;
            $("#ButtonUseAdditionalDriverOne").closest(".row").show();
            // refresh form
            $("#Driver_Additional1Title").data("kendoDropDownList").select(0);
            $("#Driver_Additional1FirstName").val("");
            $("#Driver_Additional1Surname").val("");
            $('#Driver_Additional1Title, #Driver_Additional1FirstName, #Driver_Additional1Surname').removeAttr("required");
        });
        // Additional Driver 2 (Driver 3 of 3)
        $("#AdditionalDriver2").hide();
        $("#ButtonUseAdditionalDriverTwo").click(function() {
            var validator = _this.BindValidation($(".slide:visible").attr("id"));
            if (validator.validate()) {
                $("#AdditionalDriver1").hide();
                $("#AdditionalDriver2").show();
                _this.DisplayStage(_this.driverDetails, 2);
                $('#Driver_Additional2Title, #Driver_Additional2FirstName, #Driver_Additional2Surname').attr('required', 'required');
                _this.numOfDrivers = 3;
                $("#ButtonUseAdditionalDriverTwo").closest(".row").hide();
                $("#ButtonDoNotUseAdditionalDriverOne").closest(".row").hide();
            }
        });
        $("#ButtonDoNotUseAdditionalDriverTwo").click(function() {
            var validator = _this.BindValidation($(".slide:visible").attr("id"));
            validator.hideMessages();
            _this.DisplayStage(_this.driverDetails, 1);
            $("#AdditionalDriver2").delay(500).hide();
            _this.numOfDrivers = 2;
            $("#ButtonUseAdditionalDriverTwo").closest(".row").show();
            $("#ButtonDoNotUseAdditionalDriverOne").closest(".row").show();
            // refresh form
            $("#Driver_Additional2Title").data("kendoDropDownList").select(0);
            $("#Driver_Additional2FirstName").val("");
            $("#Driver_Additional2Surname").val("");
            $('#Driver_Additional2Title, #Driver_Additional2FirstName, #Driver_Additional2Surname').removeAttr("required");
        });
        // Data Protection
        $("#ButtonBackToDriverFromDataProtection").click(function() {
            (0, $f736a2b71cdbd3b5$export$2e2bcd8739ae039).RemoveValidationStyles($('.privacyCheckboxValidation'));
            _this.ShowStage(_this.driverDetails, false, _this.numOfDrivers - 1);
            $("#DataProtectionSlide").delay(500).hide();
        });
        // Delivery Address
        $("#AddressDelivery, #AddressDeliveryAddressList").hide();
        $("#ButtonUseDeliveryAddress").click(function() {
            _this.useDeliveryAddress = true;
            $("#AddressDelivery, #AddressDeliveryAddressList").show();
            $("#ButtonUseDeliveryAddress").hide();
            $("#CopyDeliveryToInvoice").show();
            $("#ButtonDoNotUseDeliveryAddress").show();
            $("#UseDeliveryAddress").val("y");
            $("#MainDriverAddress span").hide();
            $("#AddressDelivery :input").each(function() {
                if ($(this).attr("cached-required")) {
                    $(this).removeAttr("cached-required");
                    $(this).attr("required", "required");
                }
            });
            $(".delivery-address-next-button").addClass("ml-2");
        });
        $("#ButtonDoNotUseDeliveryAddress").click(function() {
            _this.useDeliveryAddress = false;
            $("#AddressDelivery, #AddressDeliveryAddressList").hide();
            $("#ButtonUseDeliveryAddress").show();
            $("#ButtonDoNotUseDeliveryAddress").hide();
            $("#CopyDeliveryToInvoice").hide();
            $("#UseDeliveryAddress").val("n");
            $("#MainDriverAddress span").show();
            $("#AddressDelivery :input").val("");
            $("#AddressDelivery :input").each(function() {
                if ($(this).attr("required")) {
                    $(this).removeAttr("required");
                    $(this).attr("cached-required", true);
                }
            });
            $(".delivery-address-next-button").removeClass("ml-2");
        });
        // Invoice Address
        $("#AddressInvoice, #AddressInvoiceAddressList").hide();
        $("#ButtonUseInvoiceAddress").click(function() {
            _this.useInvoiceAddress = true;
            if ($("#AddressDelivery").is(":visible")) $("#CopyDeliveryToInvoice").show();
            $("#AddressInvoice, #AddressInvoiceAddressList").show();
            $("#ButtonUseInvoiceAddress").hide();
            $("#ButtonDoNotUseInvoiceAddress").show();
            $("#UseInvoiceAddress").val("y");
            $("#InvoiceAddress span").hide();
            $("#AddressInvoice :input").each(function() {
                if ($(this).attr("cached-required")) {
                    $(this).removeAttr("cached-required");
                    $(this).attr("required", "required");
                }
            });
            $(".invoice-address-next-button").addClass("ml-2");
        });
        $("#ButtonDoNotUseInvoiceAddress").click(function() {
            _this.useInvoiceAddress = false;
            $("#CopyDeliveryToInvoice").show();
            $("#AddressInvoice, #AddressInvoiceAddressList").hide();
            $("#ButtonUseInvoiceAddress").show();
            $("#ButtonDoNotUseInvoiceAddress").hide();
            $("#UseInvoiceAddress").val("n");
            $("#InvoiceAddress span").show();
            $("#AddressInvoice :input").val("");
            $("#AddressInvoice :input").each(function() {
                if ($(this).attr("required")) {
                    $(this).removeAttr("required");
                    $(this).attr("cached-required", true);
                }
            });
            $("#InvoiceAddress span").html(_this.GetDriverAddress());
            $(".invoice-address-next-button").removeClass("ml-2");
        });
        // Fire a click event on do not use delivery/invoice address buttons to change 'required' attribute to 'cached-required'.
        // Invoice/delivery address hidden initially, so fields are not required.
        // When they are made visible, 'cached-required' attribute is changed to 'required'
        $("#ButtonDoNotUseDeliveryAddress").trigger("click");
        $("#ButtonDoNotUseInvoiceAddress").trigger("click");
        $("#ButtonCopyDeliveryAddressToInvoiceAddress").click(function() {
            $("#AddressDelivery").kendoValidator();
            var validator = $("#AddressDelivery").data("kendoValidator");
            (0, $f736a2b71cdbd3b5$export$2e2bcd8739ae039).BindValidationStyles(validator);
            var addressValidated = validator.validate();
            if (addressValidated) {
                let addressName = $("#Driver_Title").val();
                if ($("#Driver_MainFirstName").val().length > 0) addressName += ` ${$("#Driver_MainFirstName").val()}`;
                addressName += ` ${$("#Driver_MainSurname").val()}`;
                addressName.trim();
                _this.useInvoiceAddress = true;
                $("#AddressInvoiceAddress_Name").val(addressName);
                $("#AddressInvoiceAddress_AddressLine1").val($("#AddressDeliveryAddress_AddressLine1").val());
                $("#AddressInvoiceAddress_AddressLine2").val($("#AddressDeliveryAddress_AddressLine2").val());
                $("#AddressInvoiceAddress_Town").val($("#AddressDeliveryAddress_Town").val());
                $("#AddressInvoiceAddress_County").val($("#AddressDeliveryAddress_County").val());
                $("#AddressInvoicePostcode").val($("#AddressDeliveryPostcode").val());
                $("#InvoiceAddress span").html(_this.GetInvoiceAddress());
                $("#ButtonDoNotUseInvoiceAddress").show();
                $("#CopyDeliveryToInvoice").hide();
            }
        });
        _this.BindDatePicker();
        (0, $0f9b377c2aa86abc$export$f5c65d7eccbf77d4).BindControls();
        $(".nextButton span").html("Next");
        _this.BindNextButton(_this.driverDetails, _this.ve103Details);
        $(".nextSlideButton").on("click", function() {
            const validator = _this.BindValidation($(".slide:visible").attr("id"));
            const validated = validator.validate();
            if (validated) {
                const activeSlide = _this.GetActiveSlide();
                switch(activeSlide.Index){
                    case 1:
                        if ($('#InvoiceAddressContainer').css('display') == 'none') {
                            $("#AddressInvoice :input").each(function() {
                                if ($(this).attr("required")) $(this).removeAttr("required");
                            });
                            $(".nextButton").first().trigger('click');
                        } else {
                            _this.DisplayStage(_this.postageDetails, 2);
                            $('#postageDetailsTitle').text('Invoice');
                            if ($("#AddressInvoiceAddress_AddressLine1").val() === '') $("#InvoiceAddress span").html(_this.GetDriverAddress());
                            else $("#InvoiceAddress span").html(_this.GetInvoiceAddress());
                        }
                        break;
                    default:
                        _this.DisplayStage(_this.postageDetails, 1);
                }
            }
        });
        $(".backSlideButton").click(function() {
            const activeSlide = _this.GetActiveSlide();
            $('#postageDetailsTitle').text('Postal Service');
            _this.DisplayStage(_this.postageDetails, activeSlide.Index - 1);
        });
        _this.BindTitles();
        //_utilities.BuildMobileBreadcrumbNav();
        // remove 8 n 9 breadcrumb
        if (LAYOUT_MODE == 'mode2') {
            $('#mobileBreadcrumbNav .mobile-breadcrumb:nth-last-child(2)').remove();
            $('#mobileBreadcrumbNav .mobile-breadcrumb:nth-last-child(2)').remove();
        }
        // Allow user to navigate to different sections from summary page
        let summaryPanel = $("#SummaryDetails");
        summaryPanel.find("a").on("click", function() {
            // The links have data attributes representing the section and slide
            let anchor = $(this).data().sectionAnchor;
            let slide = $(this).data().sectionSlide;
            if (anchor) {
                _this.clicked = true;
                // Show a button to allow navigation back to summary
                let targetSection = $(`div[data-anchor="${anchor}"]`);
                if (targetSection.find(".back-to-summary")) targetSection.find(".back-to-summary").show();
                // Go to section
                let stage = _this.TranslateAnchorToStage(anchor);
                if (slide !== null) _this.ShowStage(stage, false, slide);
                else _this.ShowStage(stage, false);
            }
        });
        // Allow navigation back to summary
        $(".back-to-summary").on("click", function(event) {
            _this.clicked = true;
            _this.returnToSummary = true;
            _this.MoveToNextSection($(this).closest(".section"));
        });
        $('input.submitOnEnter').on('keyup', function(event) {
            if (event.keyCode === 13) {
                event.preventDefault();
                let btn = $(this).closest('.section').find('.btn-success');
                btn.trigger('click');
            }
        });
    }
    BindNextButton(stageNext, stageCurrent) {
        let _this = this;
        $(".nextButton").unbind("click");
        $(".nextButton").click(function() {
            if ($(this).hasClass("createCertificateButton")) {
                if ($('#newPrivacyCheckBox').prop("checked")) {
                    $('#DataProtectionSummary').hide();
                    _this.CreateCertificate();
                } else $('#DataProtectionSummary').show();
            } else switch(stageCurrent.toLowerCase()){
                case 'vehicledetails':
                    var mileageNotRequired = $('#mileageContainer').is(':hidden');
                    if (mileageNotRequired) {
                        _this.clicked = true;
                        _this.Navigate(stageNext);
                    } else {
                        let validator = (0, $f736a2b71cdbd3b5$export$2e2bcd8739ae039).GetVehicleValidator();
                        let reasonValid = $('#AskBusinessUse').hasClass('d-none') ? true : $('#PersonalUse').kendoValidator().data('kendoValidator').validate();
                        let valid = validator.validate();
                        if (valid & reasonValid & (0, $f736a2b71cdbd3b5$export$2e2bcd8739ae039).GetExtraValidator()) {
                            if (!_this.model.class && $("#vehicle-class-select").val().toUpperCase() === 'LCV' && _this.model.isAllowedAbroad !== 1) {
                                (0, $f736a2b71cdbd3b5$export$2e2bcd8739ae039).ShowUserMessage('Vehicle Not Allowed Abroad', SITE_NOT_ALLOWED_MSG, false);
                                $('#fullPageContainer').hide();
                                kendo.ui.progress($('body'), false);
                                return;
                            }
                            _this.clicked = true;
                            _this.Navigate(stageNext);
                        }
                    }
                    break;
                case 've103infopage1details':
                    if ($('#agreedProceed').is(':checked')) {
                        $('#agreedProceed').next('label').removeClass('text-danger');
                        _this.clicked = true;
                        _this.Navigate(stageNext);
                    } else $('#agreedProceed').next('label').addClass('text-danger');
                    break;
                case 've103infopage2details':
                    if ($('#agreedUnderstood').is(':checked')) {
                        $('#agreedUnderstood').next('label').removeClass('text-danger');
                        _this.clicked = true;
                        _this.Navigate(stageNext);
                    } else $('#agreedUnderstood').next('label').addClass('text-danger');
                    break;
                case 've103details':
                    _this.clicked = true;
                    if (_this.viewModel.travelKit.travelKitPage) {
                        _this.ShowHideTravelKits();
                        _this.Navigate(_this.travelkits);
                    } else _this.Navigate(stageNext);
                    break;
                case 'travelkits':
                    if ($('#agreedTravelKitsUnderstood').is(':checked')) {
                        $('#agreedTravelKitsUnderstood').next('label').removeClass('text-danger');
                        $('#TravelKitWarningTextError').hide();
                        _this.clicked = true;
                        _this.Navigate(stageNext);
                    } else {
                        $('#TravelKitWarningTextError').show();
                        $('#agreedTravelKitsUnderstood').next('label').addClass('text-danger');
                    }
                    break;
                default:
                    _this.clicked = true;
                    _this.Navigate(stageNext);
                    break;
            }
        });
        $('#agreedProceed, #agreedUnderstood').unbind().change(function() {
            if (this.checked) {
                _this.clicked = true;
                $(this).closest('.card').find('.nextButton').parent().removeClass('d-none');
            } else $(this).closest('.card').find('.nextButton').parent().addClass('d-none');
        });
    }
    ResetProductDropdowns() {
        for(let i = 1; i <= 3; i++){
            let dropdown = $(`#TravelKitProduct${i}Units`).data("kendoDropDownList");
            if (dropdown) {
                dropdown.value(0); // Set to value 0
                dropdown.trigger("change"); // Update any UI/text
            }
        }
    }
    BindBackButton(stageNext, stageCurrent) {
        let _this = this;
        $(".backButton").unbind("click");
        if (stageCurrent === _this.postageDetails) $(".backButton").click(function() {
            var activeSlide = _this.GetActiveSlide();
            if (!activeSlide) return;
            switch(activeSlide.Index){
                case 0:
                    _this.clicked = true;
                    _this.NavigateBack(stageNext);
                    break;
                case 1:
                    _this.DisplayStage(_this.postageDetails, 0);
                    $("#PostageDetails .nextButton span").html("Next");
                    break;
                case 2:
                    _this.DisplayStage(_this.postageDetails, 1);
                    if (_this.orderTotal > 0) setTimeout(function() {
                        $("#PostageDetails .nextButton span").html("Next");
                    }, 300);
                    break;
            }
        });
        else $(".backButton").click(function() {
            $('[data-toggle="tooltip"]').tooltip('hide');
            if ($(this).html() === "Not My Vehicle") location.reload(true);
            else {
                _this.clicked = true;
                _this.NavigateBack(stageNext);
            }
        });
    }
    BindTitles() {
        $("#Driver_Title,#Driver_Additional1Title,#Driver_Additional2Title").kendoDropDownList({
            dataSource: {
                transport: {
                    read: {
                        url: "/Driver/GetAllDriverTitles"
                    }
                }
            },
            dataTextField: "text",
            dataValueField: "value"
        });
    }
    BindValidation(stage) {
        let _this = this;
        _this.stages.forEach(function(s) {
            var validator = $(`#${s}`).data("kendoValidator");
            if (validator !== undefined) validator.destroy();
        });
        var container = $(`#${stage}`);
        container.kendoValidator({
            rules: {
                atLeastOneNumber: function(input) {
                    if (input[0].id === "AlternativePhone" || input[0].id === "Mobile") {
                        var value = "";
                        $(container).find("#AlternativePhone,#Mobile").each(function(index) {
                            value += $(this).val();
                        });
                        if (value.length > 0) {
                            (0, $f736a2b71cdbd3b5$export$2e2bcd8739ae039).RemoveValidationStyles(input);
                            return true;
                        }
                        return false;
                    }
                    (0, $f736a2b71cdbd3b5$export$2e2bcd8739ae039).RemoveValidationStyles(input);
                    return true;
                },
                dataProtection: function(input) {
                    var activeSlide = _this.GetActiveSlide();
                    if (activeSlide && activeSlide.Id === "DataProtectionSlide" && input[0].id === "PrivacyCheckBox") return $(container).find("#PrivacyCheckBox").is(":checked");
                    return true;
                },
                radio: function(input) {
                    if (input.filter("[type=radio]").length > 0 && input.attr("required")) return $(container).find(`[name=${input.attr("name")}]`).is(":checked");
                    return true;
                }
            },
            messages: {
                radio: "Select an option"
            }
        });
        var validator = $(container).data("kendoValidator");
        (0, $f736a2b71cdbd3b5$export$2e2bcd8739ae039).BindValidationStyles(validator);
        return validator;
    }
    ShowStage(stage, fromVehicleSearch, slideIndex) {
        let _this = this;
        // hide all sections and slides
        $(".section").hide();
        $(".slide").hide();
        $(".nextButton").show();
        _this.currentStage = stage;
        switch(stage){
            case _this.vehicleSearchDetails:
                break;
            case _this.vehicleDetails:
                gtag('event', 'entered', {
                    'event_category': 'section',
                    'event_label': '2: FT - Vehicle Details'
                });
                if (fromVehicleSearch === true) _this.clicked = true;
                _this.BindNextButton(_this.ve103InfoPage1Details, _this.currentStage);
                _this.BindBackButton(_this.vehicleSearchDetails, _this.currentStage);
                break;
            case _this.ve103InfoPage1Details:
                gtag('event', 'entered', {
                    'event_category': 'section',
                    'event_label': '3: FT - Info Page 1'
                });
                _this.BindNextButton(_this.ve103InfoPage2Details, _this.currentStage);
                _this.BindBackButton(_this.vehicleDetails, _this.currentStage);
                break;
            case _this.ve103InfoPage2Details:
                gtag('event', 'entered', {
                    'event_category': 'section',
                    'event_label': '4: FT - Info Page 2'
                });
                _this.BindNextButton(_this.ve103Details, _this.currentStage);
                _this.BindBackButton(_this.ve103InfoPage1Details, _this.currentStage);
                break;
            case _this.ve103Details:
                if (_this.model.businessUse === 'Y') {
                    if ($('#PersonalUse').val() === 'N') {
                        $("#CompanyPaysMsg").removeClass('d-none');
                        $("#VE103Cost").text("\xa30.00");
                    } else {
                        let cost = _this.viewModel.vE103Cost;
                        $("#VE103Cost").text(`\xa3${cost.toFixed(2)}`);
                        $("#CompanyPaysMsg").addClass('d-none');
                    }
                }
                gtag('event', 'entered', {
                    'event_category': 'section',
                    'event_label': '5: FT - VE103 Details'
                });
                _this.BindNextButton(_this.driverDetails, _this.currentStage);
                _this.BindBackButton(_this.ve103InfoPage2Details, _this.currentStage);
                break;
            case _this.travelkits:
                gtag('event', 'entered', {
                    'event_category': 'section',
                    'event_label': '6: FT - Travel Kits'
                });
                _this.ShowHideTravelKits();
                _this.BindNextButton(_this.driverDetails, _this.currentStage);
                _this.BindBackButton(_this.ve103Details, _this.currentStage);
                break;
            case _this.driverDetails:
                gtag('event', 'entered', {
                    'event_category': 'section',
                    'event_label': '7: FT - Driver Details'
                });
                _this.BindNextButton(_this.driverAddressDetails, _this.currentStage);
                if (_this.viewModel.travelKit.travelKitPage) _this.BindBackButton(_this.travelkits, _this.currentStage);
                else _this.BindBackButton(_this.ve103Details, _this.currentStage);
                break;
            case _this.driverAddressDetails:
                gtag('event', 'entered', {
                    'event_category': 'section',
                    'event_label': '8: FT - Driver Address Details'
                });
                _this.BindNextButton(_this.postageDetails, _this.currentStage);
                _this.BindBackButton(_this.driverDetails, _this.currentStage);
                break;
            case _this.postageDetails:
                gtag('event', 'entered', {
                    'event_category': 'section',
                    'event_label': '9: FT - Postage Details'
                });
                $("#MainDriverAddress span").html(_this.GetDriverAddress());
                if ($("#AddressInvoiceAddress_AddressLine1").val() === '') $("#InvoiceAddress span").html(_this.GetDriverAddress());
                else $("#InvoiceAddress span").html(_this.GetInvoiceAddress());
                $("#AddressDelivery :input").each(function() {
                    if ($(this).attr("required")) {
                        $(this).removeAttr("required");
                        $(this).attr("cached-required", true);
                    }
                });
                $("#AddressInvoice :input").each(function() {
                    if ($(this).attr("required")) {
                        $(this).removeAttr("required");
                        $(this).attr("cached-required", true);
                    }
                });
                _this.BindNextButton(_this.summaryDetails, _this.currentStage);
                _this.BindBackButton(_this.driverAddressDetails, _this.currentStage);
                break;
            case _this.summaryDetails:
                gtag('event', 'entered', {
                    'event_category': 'section',
                    'event_label': '9: FT - Summary'
                });
                var totalCost = _this.orderTotal;
                if (_this.model.businessUse === 'Y') {
                    if ($('#PersonalUse').val() === 'N') totalCost -= _this.viewModel.vE103Cost;
                }
                if (_this.viewModel.travelKit.travelKitPage) totalCost += _this.ShowTravelKitSummary(totalCost);
                if (totalCost <= 0) $("#SummaryDetails .nextButton span").html("Order Certificate");
                else $("#SummaryDetails .nextButton span").html("Proceed to Payment");
                _this.PopulateSummary(totalCost);
                _this.BindNextButton(_this.paymentDetails, _this.currentStage);
                _this.BindBackButton(_this.postageDetails, _this.currentStage);
                break;
            case _this.confirmation:
                $("#CertificateReference").text(_this.certificateReference);
                $(".nextButton").hide();
                break;
        }
        let anchor = _this.TranslateStageToAnchor(stage);
        _this.DisplayStage(stage, slideIndex);
        _this.RefreshPageModel();
        (0, $254a84bc556d8bd3$export$366dc4c52172531e).RefreshMobileBreadcrumbNav();
    }
    ShowHideTravelKits() {
        let _this = this;
        // If travel kits are an option and the start date is more than 5 days in the future then show the items
        _this.IsStartDateWithinPeriod().done(function(isWithin) {
            if (isWithin) {
                $("#TravelKitItems").show();
                $("#TravelKitDeliveryCost").show();
            } else {
                $("#TravelKitItems").hide();
                $("#TravelKitDeliveryCost").hide();
                _this.ResetProductDropdowns();
            }
        });
    }
    PostageDetails(stage, slideIndex) {
        // hide all sections and slides
        $(".section").hide();
        $(".slide").hide();
        // Show the required stage/slide
        if ($.isNumeric(slideIndex)) {
            $(`#${stage}`).show();
            $($(`#${stage}`).find(".slide")[slideIndex]).show();
        } else $(`#${stage}`).show();
    }
    DisplayStage(stage, slideIndex) {
        // hide all sections and slides
        $(".section").hide();
        $(".slide").hide();
        // Show the required stage/slide
        if ($.isNumeric(slideIndex)) {
            $(`#${stage}`).show();
            $($(`#${stage}`).find(".slide")[slideIndex]).show();
        } else $(`#${stage}`).show();
    }
    GetActiveSlide() {
        var activeSlideId = "";
        var activeSlideIndex = 0;
        var count = 0;
        $(".section:visible").find(".slide").each(function() {
            if ($(this).is(":visible")) {
                activeSlideId = $(this).attr("id");
                activeSlideIndex = count;
            }
            count++;
        });
        return {
            Index: activeSlideIndex,
            Id: activeSlideId
        };
    }
    ShowTravelKitSummary(totalCost) {
        let _this = this;
        $("#TravelKitsSummary").show();
        let summaryTravelKits = "";
        for(let i = 1; i <= 3; i++){
            let productCost = this.viewModel.travelKit[`product${i}Cost`]; // Get cost dynamically
            let productUnits = $(`#TravelKitProduct${i}Units`).val(); // Get units dynamically
            let productName = $(`#TravelKitProduct${i}Name`).text().trim();
            // Multiply cost by units
            let travelKitCost = productCost * productUnits + _this.viewModel.travelKit.deliveryCost;
            if (productUnits > 0) summaryTravelKits += `${productName} - \xa3${travelKitCost.toFixed(2)} - #${productUnits}<br/>`;
        }
        totalCost = this.SumTravelKits(_this.viewModel.travelKit.deliveryCost);
        // Check if string is null or empty (length 0)
        if (summaryTravelKits.length === 0) _this.IsStartDateWithinPeriod().done(function(isWithin) {
            if (isWithin) $("#SummaryTravelKits").text("None selected");
            else $("#SummaryTravelKits").text("");
        });
        else $("#SummaryTravelKits").html(summaryTravelKits);
        return totalCost;
    }
    PopulateSummary(totalCost) {
        let _this = this;
        if (_this.viewModel.hpi.exRegNo) $("#SummaryRegistration").text(_this.viewModel.hpi.exRegNo);
        else $("#SummaryRegistration").text(_this.viewModel.vehicle.registration);
        if (_this.viewModel.hpi.exMake) $("#SummaryMake").text(_this.viewModel.hpi.exMake);
        else $("#SummaryMake").text(_this.viewModel.vehicle.manufacturer);
        if (_this.viewModel.hpi.exModel) $("#SummaryModel").text(_this.viewModel.hpi.exModel);
        else $("#SummaryModel").text(_this.viewModel.vehicle.description);
        if (_this.viewModel.hpi.exFirstRegDate) {
            $("#SummaryRegisteredDate").closest(".row").show();
            $("#SummaryRegisteredDate").text(kendo.toString(new Date(_this.viewModel.hpi.exFirstRegDate), "dd/MM/yyyy"));
        } else $("#SummaryRegisteredDate").closest(".row").hide();
        if (_this.viewModel.hpi.exColour) {
            $("#SummaryColour").closest(".row").show();
            $("#SummaryColour").text(_this.viewModel.hpi.exColour);
        } else $("#SummaryColour").closest(".row").hide();
        if (_this.viewModel.vehicle.businessUse === 'Y') {
            let val = $('#PersonalUse').val() === 'Y' ? 'Pleasure' : 'Business';
            $("#SummaryBusinessUse").closest(".row").show();
            $("#SummaryBusinessUse").text(val);
        } else $("#SummaryBusinessUse").closest(".row").hide();
        $("#SummaryLeaseCompany").text(_this.viewModel.vehicle.customerName);
        $("#SummaryCertificateStartDate").text($("#StartDate").val());
        $("#SummaryMainDriver").text(`${$("#Driver_Title").val()} ${$("#Driver_MainFirstName").val()} ${$("#Driver_MainSurname").val()}`);
        if (_this.numOfDrivers >= 2) {
            $("#SummarySecondDriver").closest(".row.no-gutters").show();
            $("#SummarySecondDriver").text(`${$("#Driver_Additional1Title").val()} ${$("#Driver_Additional1FirstName").val()} ${$("#Driver_Additional1Surname").val()}`);
        } else $("#SummarySecondDriver").closest(".row.no-gutters").hide();
        if (_this.numOfDrivers >= 3) {
            $("#SummaryThirdDriver").closest(".row.no-gutters").show();
            $("#SummaryThirdDriver").text(`${$("#Driver_Additional2Title").val()} ${$("#Driver_Additional2FirstName").val()} ${$("#Driver_Additional2Surname").val()}`);
        } else $("#SummaryThirdDriver").closest(".row.no-gutters").hide();
        var address = "";
        if ($("#AddressDriverAddress_AddressLine1").val()) address += `${$("#AddressDriverAddress_AddressLine1").val()}</br>`;
        if ($("#AddressDriverAddress_AddressLine2").val()) address += `${$("#AddressDriverAddress_AddressLine2").val()}</br>`;
        if ($("#AddressDriverAddress_Town").val()) address += `${$("#AddressDriverAddress_Town").val()}</br>`;
        if ($("#AddressDriverAddress_County").val()) address += `${$("#AddressDriverAddress_County").val()}</br>`;
        if ($("#AddressDriverPostcode").val()) address += `${$("#AddressDriverPostcode").val()}</br>`;
        $("#SummaryAddress").html(address);
        if (_this.useDeliveryAddress === true) {
            $("#SummaryDeliveryAddress").closest(".row.no-gutters").show();
            let deliveryAddress = {};
            deliveryAddress.line1 = $("#AddressDeliveryAddress_AddressLine1").val().trim();
            deliveryAddress.line2 = $("#AddressDeliveryAddress_AddressLine2").val().trim();
            deliveryAddress.town = $("#AddressDeliveryAddress_Town").val().trim();
            deliveryAddress.county = $("#AddressDeliveryAddress_County").val().trim();
            deliveryAddress.postcode = $("#AddressDeliveryPostcode").val().trim();
            $("#SummaryDeliveryAddress").html('');
            for(let prop in deliveryAddress){
                if (deliveryAddress.hasOwnProperty(prop)) {
                    if (deliveryAddress[prop]) $("#SummaryDeliveryAddress").append(`${deliveryAddress[prop]}</br>`);
                }
            }
        } else {
            $("#SummaryDeliveryAddress").closest(".row.no-gutters").show();
            $("#SummaryDeliveryAddress").html(address);
        }
        if (_this.useInvoiceAddress === true) {
            $("#SummaryInvoiceAddress").closest(".row.no-gutters").show();
            let invoiceAddress = {};
            invoiceAddress.line1 = $("#AddressInvoiceAddress_AddressLine1").val().trim();
            invoiceAddress.line2 = $("#AddressInvoiceAddress_AddressLine2").val().trim();
            invoiceAddress.town = $("#AddressInvoiceAddress_Town").val().trim();
            invoiceAddress.county = $("#AddressInvoiceAddress_County").val().trim();
            invoiceAddress.postcode = $("#AddressInvoicePostcode").val().trim();
            $("#SummaryInvoiceAddress").html('');
            for(let prop in invoiceAddress){
                if (invoiceAddress.hasOwnProperty(prop)) {
                    if (invoiceAddress[prop]) $("#SummaryInvoiceAddress").append(`${invoiceAddress[prop]}</br>`);
                }
            }
        } else {
            let $invoiceAddressItem = $("#SummaryInvoiceAddress").closest(".row.no-gutters");
            if ($('#InvoiceAddressContainer').css('display') == 'none') $invoiceAddressItem.hide();
            else $invoiceAddressItem.show();
            $("#SummaryInvoiceAddress").html(address);
        }
        $("#SummaryPostage").html(_this.postageService);
        $("#SummaryCost").html(`\xa3${Number.parseFloat(totalCost).toFixed(2)}`);
    }
    StripHtml(html) {
        let tmp = document.createElement("DIV");
        tmp.innerHTML = html;
        return tmp.textContent || tmp.innerText || "";
    }
    RefreshPageModel() {
        let _this = this;
        _this.model.Vehicle = {
            RegNumber: _this.viewModel.hpi.exRegNo ? _this.viewModel.hpi.exRegNo : _this.viewModel.vehicle.registration,
            FirstRegDate: _this.viewModel.hpi.exFirstRegDate ? _this.viewModel.hpi.exFirstRegDate : undefined,
            Make: _this.viewModel.hpi.exMake ? _this.viewModel.hpi.exMake : _this.viewModel.vehicle.manufacturer,
            Model: _this.viewModel.hpi.exModel ? _this.viewModel.hpi.exModel : _this.viewModel.vehicle.description,
            Color: _this.viewModel.hpi.exFirstRegDate ? _this.viewModel.hpi.exColour : undefined,
            MileageEntered: $("#Mileage").val()
        };
        _this.model.DriverCompany = _this.viewModel.vehicle.driverCompanyName;
        _this.model.LeaseCompany = _this.viewModel.vehicle.leaseCompanyName;
        _this.model.BusinessUse = _this.viewModel.vehicle.BusinessUse;
        _this.model.TravelKit = _this.viewModel.travelKit;
        _this.model.Certificate = {
            StartDate: $("#StartDate").val()
        };
        _this.model.MainDriver = {
            Title: $("#Driver_Title").val(),
            FirstName: $("#Driver_MainFirstName").val(),
            LastName: $("#Driver_MainSurname").val(),
            Address: {
                AddressLine1: $("#AddressDriverAddress_AddressLine1").val(),
                AddressLine2: $("#AddressDriverAddress_AddressLine2").val(),
                Town: $("#AddressDriverAddress_Town").val(),
                County: $("#AddressDriverAddress_County").val(),
                Postcode: $("#AddressDriverPostcode").val()
            }
        };
        if (_this.numOfDrivers >= 2) _this.model.SecondDriver = {
            Title: $("#Driver_Additional1Title").val(),
            FirstName: $("#Driver_Additional1FirstName").val(),
            LastName: $("#Driver_Additional1Surname").val()
        };
        else _this.model.SecondDriver = undefined;
        if (_this.numOfDrivers >= 3) _this.model.ThirdDriver = {
            Title: $("#Driver_Additional2Title").val(),
            FirstName: $("#Driver_Additional2FirstName").val(),
            LastName: $("#Driver_Additional2Surname").val()
        };
        else _this.model.ThirdDriver = undefined;
        _this.model.DeliveryAddress = _this.useDeliveryAddress !== true ? _this.model.MainDriver.Address : {
            AddressLine1: $("#AddressDeliveryAddress_AddressLine1").val().trim(),
            AddressLine2: $("#AddressDeliveryAddress_AddressLine2").val().trim(),
            Town: $("#AddressDeliveryAddress_Town").val().trim(),
            County: $("#AddressDeliveryAddress_County").val().trim(),
            Postcode: $("#AddressDeliveryPostcode").val().trim()
        };
        _this.model.InvoiceAddress = _this.useInvoiceAddress !== true ? _this.model.MainDriver.Address : {
            AddressLine1: $("#AddressInvoiceAddress_AddressLine1").val().trim(),
            AddressLine2: $("#AddressInvoiceAddress_AddressLine2").val().trim(),
            Town: $("#AddressInvoiceAddress_Town").val().trim(),
            County: $("#AddressInvoiceAddress_County").val().trim(),
            Postcode: $("#AddressInvoicePostcode").val().trim()
        };
        _this.model.PostageService = _this.postageService;
        _this.model.OrderTotal = `\xa3${Number.parseFloat(_this.orderTotal).toFixed(2)}`;
    }
    OrderTotal() {
        let _this = this;
        var result = $.Deferred();
        if ($("input[name='Postage']:checked").val() !== undefined) {
            _this.postageServiceId = $("input[name=Postage]:checked").val();
            let postageItem = _this.postageOptions.filter((option)=>option.id.toString() === _this.postageServiceId)[0];
            _this.postageService = postageItem.description;
            _this.postageServiceCode = postageItem.code;
            if (_this.postageServiceCode.toUpperCase() !== 'STANDARD') $("#ConfirmPostalContainer").removeClass('d-none');
            else $("#ConfirmPostalContainer").addClass('d-none');
        }
        $.ajax({
            url: `/foreigntravel/getordertotal?postageserviceid=${_this.postageServiceId}`,
            type: "GET",
            cache: false,
            success: function(data, status, xhr) {
                result.resolve(data);
            },
            error: function(xhr, ajaxOptions, thrownError) {
                console.log(xhr.status);
                console.log(xhr.responseText);
                console.log(thrownError);
                kendo.ui.progress($("#VehicleSearchForm"), false);
                (0, $f736a2b71cdbd3b5$export$2e2bcd8739ae039).ShowGenericError();
            }
        });
        return result.promise();
    }
    CreateCertificate() {
        let _this = this;
        if (!_this.createCertificatePressed) {
            _this.createCertificatePressed = true;
            var validator = _this.BindValidation($(".section:visible").attr("id"));
            if (!validator.validate()) return;
            var seats = null;
            var colour = null;
            var vehicleClass = null;
            if (_this.viewModel.hpi.exSeating) seats = _this.viewModel.hpi.exSeating;
            else seats = $("#vehicle-number-of-seats-select").val();
            if (_this.viewModel.hpi.exColour) colour = _this.viewModel.hpi.exColour;
            else colour = $("#vehicle-colour-select").val();
            if (_this.viewModel.vehicle.class) vehicleClass = _this.viewModel.vehicle.class;
            else vehicleClass = $("#vehicle-class-select").val();
            var data = {
                PostageServiceID: _this.postageServiceId,
                StartDate: $("#StartDate").val(),
                Telephone: $("#AlternativePhone").val().length > 0 ? $("#AlternativePhone").val() : $("#Mobile").val(),
                Email: $("#Email").val(),
                DriverMainTitle: $("#Driver_Title").val(),
                DriverMainFirstName: $("#Driver_MainFirstName").val(),
                DriverMainSurname: $("#Driver_MainSurname").val(),
                DriverMainAddressLine1: $("#AddressDriverAddress_AddressLine1").val(),
                DriverMainAddressLine2: $("#AddressDriverAddress_AddressLine2").val(),
                DriverMainTown: $("#AddressDriverAddress_Town").val(),
                DriverMainCounty: $("#AddressDriverAddress_County").val(),
                DriverMainPostcode: $("#AddressDriverPostcode").val(),
                AdditionalDriver1_Title: $("#Driver_Additional1Title").val(),
                AdditionalDriver1_FirstName: $("#Driver_Additional1FirstName").val(),
                AdditionalDriver1_Surname: $("#Driver_Additional1Surname").val(),
                AdditionalDriver2_Title: $("#Driver_Additional2Title").val(),
                AdditionalDriver2_FirstName: $("#Driver_Additional2FirstName").val(),
                AdditionalDriver2_Surname: $("#Driver_Additional2Surname").val(),
                DeliveryAddressName: $("#AddressDeliveryAddress_Name").val(),
                DeliveryAddressLine1: $("#AddressDeliveryAddress_AddressLine1").val(),
                DeliveryAddressLine2: $("#AddressDeliveryAddress_AddressLine2").val(),
                DeliveryTown: $("#AddressDeliveryAddress_Town").val(),
                DeliveryCounty: $("#AddressDeliveryAddress_County").val(),
                DeliveryPostcode: $("#AddressDeliveryPostcode").val(),
                InvoiceAddressName: $("#AddressInvoiceAddress_Name").val(),
                InvoiceAddressLine1: $("#AddressInvoiceAddress_AddressLine1").val(),
                InvoiceAddressLine2: $("#AddressInvoiceAddress_AddressLine2").val(),
                InvoiceTown: $("#AddressInvoiceAddress_Town").val(),
                InvoiceCounty: $("#AddressInvoiceAddress_County").val(),
                InvoicePostcode: $("#AddressInvoicePostcode").val(),
                UseDeliveryAddress: $("#UseDeliveryAddress").val(),
                UseBillingAddress: $("#UseInvoiceAddress").val(),
                VehicleClass: vehicleClass,
                VehicleNumberOfSeats: seats,
                VehicleColour: colour,
                PersonalUse: $("#PersonalUse").val()
            };
            // Populate the TravelKit object from the form
            if (this.viewModel.travelKit.travelKitPage) data.TravelKit = {
                deliveryCost: this.viewModel.travelKit.deliveryCost.toFixed(2),
                deliveryCode: this.viewModel.travelKit.deliveryCode,
                Product1Name: this.viewModel.travelKit.product1Name,
                Product1Cost: this.viewModel.travelKit.product1Cost,
                Product1SKU: this.viewModel.travelKit.product1SKU,
                Product1UnitsPurchased: $("#TravelKitProduct1Units").val(),
                Product2Name: this.viewModel.travelKit.product2Name,
                Product2Cost: this.viewModel.travelKit.product2Cost,
                Product2SKU: this.viewModel.travelKit.product2SKU,
                Product2UnitsPurchased: $("#TravelKitProduct2Units").val(),
                Product3Name: this.viewModel.travelKit.product3Name,
                Product3Cost: this.viewModel.travelKit.product3Cost,
                Product3SKU: this.viewModel.travelKit.product3SKU,
                Product3UnitsPurchased: $("#TravelKitProduct3Units").val()
            };
            $.ajax({
                type: "POST",
                url: "/foreigntravel/createcertificate",
                data: data,
                dataType: "json",
                success: function(idata, status, xhr) {
                    if (xhr.status === 200) {
                        _this.certificateReference = idata.Reference;
                        if (_this.certificateReference === null) {
                            (0, $f736a2b71cdbd3b5$export$2e2bcd8739ae039).ShowGenericError();
                            return;
                        }
                        let params = new URL(document.location).searchParams;
                        let cmpParam = params.get("q");
                        if (idata.OrderTotal > 0) {
                            var addressContainer = "#AddressDriver";
                            if ($("#UseInvoiceAddress").val() === "y") addressContainer = "#AddressInvoice";
                            var address = "";
                            var addressLine1 = $(addressContainer + "Address_AddressLine1").val();
                            var addressLine2 = $(addressContainer + "Address_AddressLine2").val();
                            var addressTown = $(addressContainer + "Address_Town").val();
                            var addressCounty = $(addressContainer + "Address_County").val();
                            var addressPostcode = $(addressContainer + "Postcode").val();
                            if (addressLine1.length > 0) address += addressLine1 + ", ";
                            if (addressLine2.length > 0) address += addressLine2 + ", ";
                            if (addressTown.length > 0) address += addressTown + ", ";
                            if (addressCounty.length > 0) address += addressCounty;
                            var name = $("#Driver_Title").val() + " " + $("#Driver_MainFirstName").val() + " " + $("#Driver_MainSurname").val();
                            var telephone = $("#Telephone").val();
                            var email = $("#Email").val();
                            var description = `VE103 Foreign Travel Certificate - ${_this.StripHtml(_this.postageService)}`;
                            var registration = $("#Registration").val();
                            $("#PaymentForm [name=cartId]").val(_this.certificateReference);
                            $("#PaymentForm [name=amount]").val(idata.OrderTotal);
                            $("#PaymentForm [name=name]").val(name);
                            $("#PaymentForm [name=address]").val(address);
                            $("#PaymentForm [name=postcode]").val(addressPostcode);
                            $("#PaymentForm [name=tel]").val(telephone);
                            $("#PaymentForm [name=email]").val(email);
                            $("#PaymentForm [name=desc]").val(description);
                            $("#PaymentForm [name=MC_Registration]").val(registration);
                            $("#PaymentForm [name=signature]").val(idata.Signature);
                            $("#PaymentForm [name=MC_RedirectURL]").val(`${window.location.origin}/foreigntravel/confirmation?reference=${encodeURIComponent(_this.certificateReference)}&q=${cmpParam}`);
                            $('#PaymentForm [name=MC_RedirectCancelledURL]').val(`${window.location.origin}/foreigntravel/confirmation?q=${cmpParam}`);
                            $("#PaymentForm [name=MC_ReturnURL]").val(window.location.href + "/confirmation");
                            $("#PaymentForm").submit();
                        } else if (params.has("q")) window.location.href = `/foreigntravel/confirmation?reference=${encodeURIComponent(_this.certificateReference)}&q=${params.get("q")}`;
                        else window.location.href = `/foreigntravel/confirmation?reference=${encodeURIComponent(_this.certificateReference)}`;
                    } else (0, $f736a2b71cdbd3b5$export$2e2bcd8739ae039).ShowGenericError();
                },
                error: function(xhr, ajaxOptions, thrownError) {
                    console.log(xhr.status);
                    console.log(xhr.responseText);
                    console.log(thrownError);
                    (0, $f736a2b71cdbd3b5$export$2e2bcd8739ae039).ShowGenericError();
                    _this.createCertificatePressed = false;
                },
                complete: function() {}
            });
        }
    }
    GetDriverAddress() {
        var address = "";
        address += $("#Driver_Title").val();
        if ($("#Driver_MainFirstName").val().length > 0) address += ` ${$("#Driver_MainFirstName").val()}`;
        address += ` ${$("#Driver_MainSurname").val()}<br/>`;
        address.trim();
        if ($("#AddressDriverAddress_AddressLine1").val().length > 0) address += `${$("#AddressDriverAddress_AddressLine1").val()}<br/>`;
        if ($("#AddressDriverAddress_AddressLine2").val().length > 0) address += `${$("#AddressDriverAddress_AddressLine2").val()}<br/>`;
        if ($("#AddressDriverAddress_Town").val().length > 0) address += `${$("#AddressDriverAddress_Town").val()}<br/>`;
        if ($("#AddressDriverAddress_County").val().length > 0) address += `${$("#AddressDriverAddress_County").val()}<br/>`;
        if ($("#AddressDriverPostcode").val().length > 0) address += `${$("#AddressDriverPostcode").val().toUpperCase()}<br/>`;
        address = address.substr(0, address.lastIndexOf("<br/>"));
        return address;
    }
    GetDeliveryAddress() {
        var address = "";
        if ($("#AddressDeliveryAddress_Name").val() !== undefined) address += `${$("#AddressDeliveryAddress_Name").val()}<br/>`;
        else {
            address += $("#Driver_Title").val();
            if ($("#Driver_MainFirstName").val().length > 0) address += ` ${$("#Driver_MainFirstName").val()}`;
            address += ` ${$("#Driver_MainSurname").val()}<br/>`;
        }
        address.trim();
        if ($("#AddressDeliveryAddress_AddressLine1").val().length > 0) address += `${$("#AddressDeliveryAddress_AddressLine1").val()}<br/>`;
        if ($("#AddressDeliveryAddress_AddressLine2").val().length > 0) address += `${$("#AddressDeliveryAddress_AddressLine2").val()}<br/>`;
        if ($("#AddressDeliveryAddress_Town").val().length > 0) address += `${$("#AddressDeliveryAddress_Town").val()}<br/>`;
        if ($("#AddressDeliveryAddress_County").val().length > 0) address += `${$("#AddressDeliveryAddress_County").val()}<br/>`;
        if ($("#AddressDeliveryPostcode").val().length > 0) address += `${$("#AddressDeliveryPostcode").val().toUpperCase()}<br/>`;
        address = address.substr(0, address.lastIndexOf("<br/>"));
        return address;
    }
    GetInvoiceAddress() {
        var address = "";
        if ($("#AddressInvoiceAddress_Name").val() !== undefined) address += `${$("#AddressInvoiceAddress_Name").val()}<br/>`;
        else {
            address += $("#Driver_Title").val();
            if ($("#Driver_MainFirstName").val().length > 0) address += ` ${$("#Driver_MainFirstName").val()}`;
            address += ` ${$("#Driver_MainSurname").val()}<br/>`;
        }
        address.trim();
        if ($("#AddressInvoiceAddress_AddressLine1").val().length > 0) address += `${$("#AddressInvoiceAddress_AddressLine1").val()}<br/>`;
        if ($("#AddressInvoiceAddress_AddressLine2").val().length > 0) address += `${$("#AddressInvoiceAddress_AddressLine2").val()}<br/>`;
        if ($("#AddressInvoiceAddress_Town").val().length > 0) address += `${$("#AddressInvoiceAddress_Town").val()}<br/>`;
        if ($("#AddressInvoiceAddress_County").val().length > 0) address += `${$("#AddressInvoiceAddress_County").val()}<br/>`;
        if ($("#AddressInvoicePostcode").val().length > 0) address += `${$("#AddressInvoicePostcode").val().toUpperCase()}<br/>`;
        address = address.substr(0, address.lastIndexOf("<br/>"));
        return address;
    }
    SetNextButtonText() {
        let _this = this;
        _this.OrderTotal().done(function(total) {
            _this.orderTotal = total;
            if (_this.model.businessUse === 'Y') {
                if ($('#PersonalUse').val() === 'N') total -= _this.viewModel.vE103Cost;
            }
            if (total > 0) $("#InvoiceAddressContainer").show();
            else $("#InvoiceAddressContainer").hide();
            $("#PostageDetails .nextButton span").show();
        });
    }
    BindDatePicker() {
        var maxDate = new Date();
        maxDate.setDate(maxDate.getDate() + 90);
        var minDate = new Date();
        var kendoDatePicker = $("#StartDate").data("kendoDatePicker");
        if (typeof kendoDatePicker === "undefined") $("#StartDate").kendoDatePicker({
            format: "dd/MM/yyyy",
            min: minDate,
            max: maxDate
        });
        $("#StartDate").unbind("click");
        $("#StartDate").click(function() {
            $("#StartDate").data("kendoDatePicker").open();
        });
    }
    TranslateStageToAnchor(stage) {
        let _this = this;
        return _this.anchors[_this.stages.indexOf(stage)];
    }
    TranslateAnchorToStage(anchor) {
        let _this = this;
        return _this.stages[_this.anchors.indexOf(anchor)];
    }
    GetViewModel() {
        var result = $.Deferred();
        $.ajax({
            url: "/foreigntravel/viewmodel",
            type: "GET",
            cache: false,
            success: function(data) {
                result.resolve(data);
            },
            error: function(xhr, ajaxOptions, thrownError) {},
            complete: function() {}
        });
        return result.promise();
    }
    IsStartDateWithinPeriod() {
        var result = $.Deferred();
        var numberOfDays = 5;
        var startDate = $("#StartDate").val();
        $.ajax({
            url: "/foreigntravel/IsStartDateWithinPeriod",
            data: {
                selectedDate: startDate,
                numberOfDays: numberOfDays
            },
            type: "GET",
            cache: false,
            success: function(response) {
                result.resolve(response);
            },
            error: function(xhr, ajaxOptions, thrownError) {},
            complete: function() {}
        });
        return result.promise();
    }
    Navigate(nextStage) {
        let _this = this;
        var validated;
        var validator = _this.BindValidation($(".section:visible").attr("id"));
        validated = validator.validate();
        if (nextStage === _this.ve103InfoPage1Details) validated = true;
        if (validated) {
            if (nextStage === _this.driverDetails || nextStage === _this.postageDetails) _this.ShowStage(nextStage, false, 0);
            else _this.ShowStage(nextStage, false);
            // Progress bar - Mark the currently active stage
            var currentStageIndex = _this.stages.indexOf(nextStage) - 1;
            $($(".mobile-breadcrumb-nav li")[currentStageIndex]).addClass("active");
            // Progress bar - Mark the previous stage as completed
            var previousStageIndex = _this.stages.indexOf(nextStage) - 2;
            $($(".mobile-breadcrumb-nav li")[previousStageIndex]).removeClass("active").addClass("validated");
            window.scrollTo(0, 0);
        }
    }
    NavigateBack(nextStage) {
        let _this = this;
        if (nextStage === _this.postageDetails) {
            let addressStage = 2;
            if ($('#InvoiceAddressContainer').css('display') == 'none') addressStage = 1;
            _this.ShowStage(nextStage, false, addressStage);
        } else if (nextStage === _this.driverDetails) _this.ShowStage(nextStage, false, _this.numOfDrivers - 1);
        else _this.ShowStage(nextStage, false);
    }
    MoveToNextSection($currentSection) {
        var $nextSection = $currentSection.nextAll(".section").filter(":visible").first();
        this.Navigate($nextSection.prop("id"));
    }
}
var $3a1136aee2ee508e$export$2e2bcd8739ae039 = $3a1136aee2ee508e$var$VE103;



let $f90b7548d54d161a$export$76b090c025b4ff78;
let $f90b7548d54d161a$var$vehicleLookup;
class $f90b7548d54d161a$export$2e2bcd8739ae039 {
    constructor(){
        // local fields
        this._vehicle = undefined;
        // Class initialization
        this.BindFormControls();
        if ($('#ServiceIdentifier').val() === 'VE103') $f90b7548d54d161a$export$76b090c025b4ff78 = new (0, $3a1136aee2ee508e$export$2e2bcd8739ae039)();
    }
    // --------------------------------------------------
    // GETTER AND SETTER
    // --------------------------------------------------
    get Vehicle() {
        return this._vehicle;
    }
    set Vehicle(newVehicle) {
        this._vehicle = newVehicle;
    }
    // --------------------------------------------------
    // FUNCTIONS
    // --------------------------------------------------
    BindFormControls() {
        let _this = this;
        if ($('#ServiceIdentifier').val()) $('#vehicle-search-input').focus();
        else $('#Registration').focus();
        $('.i247service .fa-info-circle').click(function() {
            var windowText = $(this).data('infotext');
            var windowTitle = $(this).data('infotitle');
            var infoWindow = $('#infoWindow').kendoWindow({
                width: 'auto',
                height: 'auto',
                position: {
                    top: 100
                }
            }).data('kendoWindow');
            infoWindow.title(windowTitle);
            infoWindow.content(windowText);
            infoWindow.center().open();
        });
        $('#ButtonSearchAgain').click(function() {
            $('#PrivacyStatement').hide();
            $('#SearchAgain').hide();
            $('#ServiceList').hide();
            $('#ServicesHeader').hide();
            $('#SearchForm').show();
        });
        $('#PrivacyCheckBox').change(function() {
            if ($(this).is(':checked')) _this.BindServiceButtons(true);
            else _this.BindServiceButtons(false);
        });
    }
    GetVehicle(vehicleRegistration, grecaptcharesponse) {
        let result = $.Deferred();
        // send the q as well, which has the customer id in it to filter the vehicles returned.
        let queryString = (0, $f736a2b71cdbd3b5$export$2e2bcd8739ae039).GetQueryStringValue('q', null);
        let url = '/vehicle/GetVehicle?q=' + queryString + '&vehicleRegistration=' + vehicleRegistration + '&grecaptcharesponse=' + grecaptcharesponse;
        $.ajax({
            url: url,
            type: 'GET',
            cache: false,
            success: function(data) {
                result.resolve(data);
            },
            error: function(xhr, ajaxOptions, thrownError) {
                console.log(xhr.status);
                console.log(xhr.responseText);
                console.log(thrownError);
                kendo.ui.progress($('body'), false);
                (0, $f736a2b71cdbd3b5$export$2e2bcd8739ae039).ShowGenericError();
            },
            complete: function() {}
        });
        return result.promise();
    }
    GetVehicleServices(vehicleRegistration) {
        var result = $.Deferred();
        var url = '/vehicle/GetServices?vehicleRegistration=' + vehicleRegistration;
        $.ajax({
            url: url,
            type: 'GET',
            cache: false,
            success: function(data) {
                result.resolve(data);
            },
            error: function(xhr, ajaxOptions, thrownError) {
                console.log(xhr.status);
                console.log(xhr.responseText);
                console.log(thrownError);
                kendo.ui.progress($('body'), false);
                (0, $f736a2b71cdbd3b5$export$2e2bcd8739ae039).ShowGenericError();
            },
            complete: function() {}
        });
        return result.promise();
    }
    GetDriverCompanySettings(driverCompanyId) {
        let result = $.Deferred();
        let url = '/foreigntravel/GetDriverCompanySettings?&driverCompanyId=' + driverCompanyId;
        $.ajax({
            url: url,
            type: 'GET',
            cache: false,
            success: function(data) {
                result.resolve(data);
            },
            error: function(xhr, ajaxOptions, thrownError) {
                console.log(xhr.status);
                console.log(xhr.responseText);
                console.log(thrownError);
                kendo.ui.progress($('body'), false);
                (0, $f736a2b71cdbd3b5$export$2e2bcd8739ae039).ShowGenericError();
            },
            complete: function() {}
        });
        return result.promise();
    }
    DoLookup(registration, grecaptcharesponse) {
        let _this = this;
        var serviceIdentifier = $('#ServiceIdentifier').val();
        $.get("/foreigntravel/CustomerLink").fail(function() {
            (0, $f736a2b71cdbd3b5$export$2e2bcd8739ae039).ShowGenericError();
        }).done(function(customer) {
            if (serviceIdentifier) {
                kendo.ui.progress($('body'), true);
                (0, $f736a2b71cdbd3b5$export$2e2bcd8739ae039).HideUserMessage();
                const registration = $('#vehicle-search-input').val().replace(' ', '').toUpperCase();
                let label = customer.name.substring(0, 1).toUpperCase() === 'A' ? 'an' : 'a';
                let serviceText = serviceIdentifier === 'VE103' ? 'Customer Service' : 'Tyres';
                let customerName = '';
                switch(customer.name){
                    case 'Omodaandjaecoo':
                        customerName = "Omoda and Jaecoo Contract Hire";
                        break;
                    case 'Mg':
                        customerName = 'MG Contract Hire';
                        break;
                    case 'Hyundai':
                        customerName = 'Hyundai Contract Hire';
                        break;
                    case 'Honda':
                        customerName = 'Honda Contract Hire';
                        break;
                    case 'Byd':
                        customerName = 'BYD';
                        break;
                    default:
                        customerName = customer.name;
                        break;
                }
                let vehicleNotFoundMessage1 = `<p>Sorry no vehicle details are currently held against registration ${registration}. Please check the registration entered and try again.</p><p>If registration still doesn\u{2019}t validate, check this is definitely ${label} ${customerName} vehicle, contact the Driverline and select the option for ${serviceText}, one of the team will then call you to assist.</p><p><a class="btn btn-success" href="javascript:window.location.href=window.location.href">Try again</a></p>`;
                _this.GetVehicle(registration, grecaptcharesponse).done(function(vehicle1) {
                    if (!vehicle1) {
                        (0, $f736a2b71cdbd3b5$export$2e2bcd8739ae039).ShowUserMessage('Vehicle Not Found', vehicleNotFoundMessage1, true);
                        kendo.ui.progress($('body'), false);
                        return;
                    }
                    _this.ShowCallMe();
                    _this.Vehicle = vehicle1;
                    // isAllowedAbroad Msg
                    if (serviceIdentifier === 'VE103' && _this.Vehicle.isAllowedAbroad != '1' && _this.Vehicle.isAllowedAbroad != null) {
                        var msg = {
                            title: '',
                            body: ''
                        };
                        switch(_this.Vehicle.isAllowedAbroad){
                            case 0:
                                msg.title = 'Vehicle Not Allowed Abroad';
                                msg.body = SITE_NOT_ALLOWED_MSG;
                                break;
                            case 2:
                                msg.title = 'Authorisation Required';
                                msg.body = SITE_AUTHORISATION_MSG;
                                break;
                        }
                        (0, $f736a2b71cdbd3b5$export$2e2bcd8739ae039).ShowUserMessage(msg.title, msg.body, false);
                        $('#fullPageContainer').hide();
                        kendo.ui.progress($('body'), false);
                        return;
                    }
                    _this.GetDriverCompanySettings(_this.Vehicle.driverCompanyId).done(function(settings) {
                        var greenCardText = settings.filter((option)=>option.sysName.toUpperCase() === 'GREENCARDTEXT')[0];
                        if (greenCardText !== undefined) $('#dcs_greenCardText').html(greenCardText.settingValue);
                    });
                    _this.GetVehicleServices(_this.Vehicle.registration).done(function(services) {
                        if (services.length === 0 || services.indexOf(serviceIdentifier) === -1) {
                            $('#no-services-found-for-vehicle-message').show();
                            $('#ServicesHeader').hide();
                            kendo.ui.progress($('body'), false);
                        } else {
                            $('#ServicesHeader').show();
                            $('#no-services-found-for-vehicle-message').hide();
                            if (serviceIdentifier === 'VE103') {
                                $f90b7548d54d161a$export$76b090c025b4ff78.SetVehicle(_this.Vehicle);
                                $f90b7548d54d161a$export$76b090c025b4ff78.Initialise();
                            }
                        }
                    });
                    if (_this.Vehicle.mileageCheckSuppression) $('#mileageContainer').hide();
                });
            } else {
                $('#PrivacyCheckBox').attr('checked', false);
                kendo.ui.progress($('body'), true);
                (0, $f736a2b71cdbd3b5$export$2e2bcd8739ae039).HideUserMessage();
                $('#ServicesHeader').hide();
                $('#ServiceList').hide();
                _this.GetVehicle(registration, grecaptcharesponse).done(function(vehicles) {
                    if (!vehicle) {
                        (0, $f736a2b71cdbd3b5$export$2e2bcd8739ae039).ShowUserMessage('Vehicle Not Found', vehicleNotFoundMessage, true);
                        _this.ShowCallMe();
                        kendo.ui.progress($('body'), false);
                        return;
                    }
                    var selectedServiceUrl = $('#SelectedServiceUrl').val();
                    if (selectedServiceUrl !== '') {
                        window.location = selectedServiceUrl;
                        return;
                    }
                    _this.Vehicle = vehicles[0];
                    _this.GetVehicleServices(_this.Vehicle.registration).done(function(services) {
                        kendo.ui.progress($('body'), false);
                        $('.i247service').hide();
                        $('#SearchAgain').hide();
                        $('#ServiceList').hide();
                        $('#PrivacyStatement').hide();
                        if (services.length === 0) {
                            (0, $f736a2b71cdbd3b5$export$2e2bcd8739ae039).ShowUserMessage('Unable to Proceed', `<p>We could not find any services associated with vehicle registration ${_this.Vehicle.registration}.</p><p>Please call your dedicated Driverline for assistance.</p>`, true);
                            return;
                        } else {
                            $('#PrivacyStatement').show();
                            $('#ServicesHeader').show();
                            $('#HeaderRegistration').text(registration.toUpperCase());
                            $('#HeaderVehicleMake').text(_this.Vehicle.manufacturer);
                            $('#HeaderVehicleDescription').text(_this.Vehicle.description);
                            $('#HeaderVehicleLeaseCompany').text(_this.Vehicle.customerName);
                            $('#HeaderVehicleDriverCompany').text(_this.Vehicle.driverCompanyName);
                            $('#SearchAgain').show();
                            $('#SearchForm').hide();
                        }
                        $.each(services, function(i, service) {
                            var selector = '#DIV' + service.toUpperCase();
                            $(selector).show();
                        });
                    });
                });
            }
        });
    }
    ShowCallMe() {
        (0, $254a84bc556d8bd3$export$366dc4c52172531e).LoadHtmlTemplate('/ForeignTravel/GetEmailForm', {}, async function(template) {
            $('#email-helper').html(template);
            (0, $f736a2b71cdbd3b5$export$2e2bcd8739ae039).InitialiseEmailSupportTab();
        });
    }
    BindServiceButtons(ShowService) {
        $('.i247service .gobutton').unbind('click');
        if (ShowService) {
            $('#ServiceList').slideDown();
            $('.i247service .gobutton').click(function() {
                window.location = $(this).data('url');
            });
        } else {
            $('#ServiceList').slideUp();
            $('.i247service .gobutton').click(function() {
                if (!$('#PrivacyCheckBox').is(':checked')) $('#PrivacyCheckBox').kendoTooltip({
                    width: 240,
                    position: 'top',
                    animation: {
                        open: {
                            effects: 'zoom',
                            duration: 150
                        }
                    }
                }).data('kendoTooltip').show();
            });
        }
    }
}
// Google Captcha Callback (Needs to be in global scope)
function $f90b7548d54d161a$var$RecaptchaCallBack(result) {
    let validator = $('#VehicleSearchFormContainer').kendoValidator().data('kendoValidator');
    (0, $f736a2b71cdbd3b5$export$2e2bcd8739ae039).BindValidationStyles(validator);
    let recaptchaResponse = grecaptcha.getResponse();
    if (!validator.validate()) return;
    let registration = $('#Registration').val();
    if ($('#ServiceIdentifier').val()) registration = $('#vehicle-search-input').val();
    registration = registration.replace(' ', '');
    grecaptcha.reset();
    $f90b7548d54d161a$var$vehicleLookup.DoLookup(registration, recaptchaResponse);
}
$(function() {
    $f90b7548d54d161a$var$vehicleLookup = new $f90b7548d54d161a$export$2e2bcd8739ae039();
    window.grecaptcha.ready(()=>{
        grecaptcha.render('vehicle-search-button', {
            'sitekey': '6LecsgkbAAAAAB6gO3yIsno1RUQoGE3VXB3rEjX3',
            'callback': $f90b7548d54d161a$var$RecaptchaCallBack
        });
    });
});



})();
//# sourceMappingURL=app.bundle.js.map
